// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-06T17:03:54.587Z
// Property: Celsius Apartment Homes (ID: 5734243929948160)
// Collections: 27 amenities, 31 floorplans (live), 38 photos, 84 POIs, 2 reviews, 1 virtual tours, 7 office hours, 1 special offers (live), 18 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5734243929948160",
  "property_external_id": "4868212",
  "property_zillow_url": "https://www.zillow.com/apartments/charlotte-nc-celsius-5XhwJG/",
  "property_apartments_url": "https://www.apartments.com/celsius-apartment-homes-charlotte-nc/79lwqlx",
  "property_google_business_url": "https://www.google.com/maps/place/Celsius+Apartment+Homes/@35.3458194,-80.8524727,15z/data=!4m2!3m1!1s0x0:0xf733a57ce91ac211?sa=X&ved=2ahUKEwjhg7Cn7-H2AhVKkmoFHWZ0DPoQ_BJ6BAgtEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443864152",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "celsius-apartment-homes",
  "property_name": "Celsius Apartment Homes",
  "property_website_url": "https://www.celsiuscharlotte.com/",
  "property_domain": "https://www.celsiuscharlotte.com/",
  "property_address": "10051 Perimeter Station Dr",
  "property_full_address": "10051 Perimeter Station Dr, Charlotte, NC 28216",
  "property_address_1": "10051 Perimeter Station Dr",
  "property_address_2": null,
  "property_address_city": "Charlotte",
  "property_address_state": "NC",
  "property_address_zip_full": "28216-3358",
  "property_address_zip": "28216",
  "property_address_country": "US",
  "property_address_county": "Mecklenburg County",
  "property_neighborhood_address": "Wedgewood",
  "property_address_latitude": "35.3458008",
  "property_address_longitude": "-80.85265509999999",
  "property_email": "celsius@alapts.com",
  "property_phone": "(704) 399-8805",
  "property_call_tracking_phone": "704-459-7350",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern Northlake living with room to recharge.</strong> Explore one-, two-, and three-bedroom apartment homes with keyless entry, Nest thermostats, in-home laundry, tall ceilings, and polished finishes—then browse <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Celsius in Charlotte.</p>",
  "property_long_description": "<p><strong>Modern Northlake living with room to recharge.</strong> At Celsius Apartment Homes, you can choose from one-, two-, and three-bedroom layouts in Charlotte’s Wedgewood/Northlake area, then come home to smart, polished details like keyless entry, Nest thermostats, in-home washer and dryer, tall ceilings, subway tile backsplash, and select kitchen islands or private outdoor space.</p><p>Outside your door, the community keeps daily life easy: two resort-style pools with sundecks, two fitness centers, resident clubhouses with WFH business centers, a coffee bar, game room, package lockers, garages, a car care center, dog park, and pet spa. Explore the full lineup of <a href=\"/amenities\">community amenities</a>, or compare available <a href=\"/floor-plans\">floor plans</a> to find the space that fits the way you like to live.</p><p>Set near Northlake Mall, I-77, and I-485, Celsius puts shopping, dining, and errands close by while keeping Uptown Charlotte, Huntersville, Nevin Community Park, Hornets Nest Park, and Latta Nature Preserve within easy reach.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019d02f4-5918-761e-8d47-609611b6229a.webp",
  "property_featured_image_media": {
    "alt_text": "Dining area and kitchen with wooden cabinets and stainless steel appliances.",
    "public_id": "019d02f4-5918-761e-8d47-609611b6229a",
    "storage_key": "property/5734243929948160/019d02f4-5918-761e-8d47-609611b6229a.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "449",
  "property_year_built": "2009",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.76391982182628",
  "property_admin_fee": "250",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Admin Fee: $250\nApplication Fee: $75\nApplication Approval Fee: Starting at $300\nNon-refundable Pet Fee: $400 for 1st, additionaly $100 for 2nd\nMonthly Pet Rent: $30/pet\nMonthly Garage: $150\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 for your 1st pet and an additional $100 for your 2nd pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 for your 1st pet and an additional $100 for your 2nd pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8726712.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://celsius.loftliving.com/login",
  "property_apply_now_url": "https://8726712.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e4391-0349-71c4-9a43-ceada245349e.webp",
  "property_primary_logo_media": {
    "alt_text": "Celsius Apartment Homes logo with a tagline 'Choose Your Chill'.",
    "public_id": "019e4391-0349-71c4-9a43-ceada245349e",
    "storage_key": "property/5734243929948160/019e4391-0349-71c4-9a43-ceada245349e.webp",
    "width": 2670,
    "height": 1812
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019d02f4-4b6e-7675-928d-0282fa30c030.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02f4-4b6e-7675-928d-0282fa30c030",
    "storage_key": "property/5734243929948160/019d02f4-4b6e-7675-928d-0282fa30c030.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e4391-02ae-726d-97a5-01f40b36364e.webp",
  "property_icon_media": {
    "alt_text": "Abstract graphic with three connected hexagons in gray, red, and green.",
    "public_id": "019e4391-02ae-726d-97a5-01f40b36364e",
    "storage_key": "property/5734243929948160/019e4391-02ae-726d-97a5-01f40b36364e.webp",
    "width": 1160,
    "height": 1161
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e4391-02ae-726d-97a5-01f40b36364e.webp",
  "property_fav_icon_media": {
    "alt_text": "Abstract graphic with three connected hexagons in gray, red, and green.",
    "public_id": "019e4391-02ae-726d-97a5-01f40b36364e",
    "storage_key": "property/5734243929948160/019e4391-02ae-726d-97a5-01f40b36364e.webp",
    "width": 1160,
    "height": 1161
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f1536-d49a-70d4-b06a-dca85fcab588.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f1536-d49a-70d4-b06a-dca85fcab588",
    "storage_key": "property/5734243929948160/019f1536-d49a-70d4-b06a-dca85fcab588.webp",
    "width": 1280,
    "height": 868
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f1536-c9cc-767b-8e36-85e00739396f.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f1536-c9cc-767b-8e36-85e00739396f",
    "storage_key": "property/5734243929948160/019f1536-c9cc-767b-8e36-85e00739396f.webp",
    "width": 1280,
    "height": 868
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#989400",
  "property_secondary_color": "#cf3339",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#53575a",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "713 - 1423",
  "property_sqft_min": "713",
  "property_sqft_max": "1423",
  "property_price_range": "1173.83 - 2059",
  "property_price_min": "1173.83",
  "property_price_max": "2059",
  "property_available_units": 28,
  "property_facebook_url": "https://www.facebook.com/CelsiusApartmentsNC",
  "property_instagram_url": "https://www.instagram.com/celsius_nc",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJDyzhmwGnVogREcIa6XylM_c",
  "property_youtube_url": "https://www.youtube.com/@CelsiusApartmentHomes",
  "property_yelp_url": "https://www.yelp.com/biz/celsius-charlotte",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities that keep pace.</strong> Celsius Apartment Homes brings standout comforts together with two swimming pools and sundecks, welcoming clubhouse spaces, a coffee bar, billiards, fitness centers, package lockers, garages, and a car wash area. Inside, enjoy streamlined finishes like in-home laundry, keyless entry, digital thermostats, tall ceilings, tile backsplash, modern appliances, and select kitchen islands or outdoor space—plus pet-friendly perks including a dog park and dog spa.</p>",
  "property_home_floorplans_blurb": "<p><strong>Choose the space that matches your rhythm.</strong> Celsius Apartment Homes offers one-, two-, and three-bedroom layouts in Charlotte with open living areas, polished finishes, and everyday conveniences built in. Look for quartz or granite countertops, subway tile backsplashes, keyless entry, in-home washers and dryers, and 9- to 10-foot ceilings, with select homes featuring kitchen islands, Nest thermostats, garden tubs, USB ports, or private outdoor space.</p>",
  "property_home_gallery_blurb": "<p><strong>See Celsius in focus.</strong> Preview polished kitchens with sleek counters, tile backsplashes, and framed cabinetry, plus open living areas with tall ceilings and wide windows. Then picture time beyond your front door: poolside seating, outdoor lounges, a fire pit, clubhouse spaces, fitness areas, game-room details, and pet-friendly features all captured in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Northlake at your fingertips.</strong> From Celsius Apartment Homes in Wedgewood, daily plans stay close: coffee at Sticks and Beans, dinner at Firebirds, shopping at Northlake Commons, and movies at AMC Northlake. With I-77, I-485, and the Northlake Park &amp; Ride nearby, Uptown, Lake Norman, and CLT-area destinations are easy to reach. For fresh air, head to Hornets Nest Park or Latta Nature Preserve.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents love the care behind the community.</strong> Reviews for Celsius Apartment Homes point to a responsive leasing team, clear communication, and a well-maintained Wedgewood setting that makes daily life feel easy. From quick follow-ups to a peaceful atmosphere, residents frequently mention team members who are “kind and helpful” and “go above and beyond to make you feel at home.”</p>",
  "property_neighborhood_blurb": "<p><strong>Set your map to Northlake.</strong> From Celsius Apartment Homes in Wedgewood, everyday Charlotte feels easy to navigate: coffee runs, casual dinners, shopping, movies, and errands all cluster along the Northlake corridor, with local favorites like Lulabelle’s, Sticks and Beans, Firebirds, and Northlake Commons close to home.</p><p>When you want a wider radius, I-77, I-485, and the Northlake Park &amp; Ride put Uptown, Lake Norman towns, and the airport side of the city within a straightforward drive. Weekends can shift from AMC Northlake and retail stops to fresh air at Hornets Nest Park or trail time, paddling, and lake views at Latta Nature Preserve. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the neighborhood fits your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living, tuned to your day.</strong> At Celsius Apartment Homes, comfort goes beyond your front door with two swimming pools and sundecks, inviting clubhouse spaces, a coffee bar, billiards, and fitness centers that make it easy to switch from productive to relaxed. Everyday details feel handled, too, with package lockers, online resident services, garages, a car wash area, recycling, and Wi-Fi available throughout the community.</p><p>Inside your Charlotte apartment, thoughtful finishes keep routines streamlined: in-home washer and dryer, keyless entry, digital thermostats, tall ceilings, tile backsplash, modern appliances, and select kitchen islands or outdoor space. Pets get their own perks with a dog park and dog spa, and you can preview more shared spaces in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience them in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Celsius home?</strong><br>Choose a one-, two-, or three-bedroom layout with polished details like keyless entry, Nest thermostats, in-home laundry, tall ceilings, and select private outdoor space. Start your application online and take the next step toward modern Northlake living with room to recharge.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the Celsius Apartment Homes leasing team for help exploring one-, two-, and three-bedroom layouts, polished in-home finishes, and easy Northlake-area access near I-77 and I-485. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Celsius Apartment Homes?</strong> Start here for quick answers about the community, leasing, floor plans, amenities, and everyday living in Charlotte’s Wedgewood/Northlake area. If you don’t see what you need, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your rhythm.</strong> Celsius Apartment Homes gives you a wide range of one-, two-, and three-bedroom apartments in Charlotte, from efficient one-bedrooms to expanded two-bedroom residences and a spacious three-bedroom option. As you compare floor plan cards, look beyond bed and bath count: notice which layouts offer extra breathing room, open living areas, and the in-home details that make daily routines smoother.</p><p>Expect polished finishes like quartz or granite countertops, subway tile backsplash, keyless entry, in-home washer and dryer, and modern 9- to 10-foot ceilings, with select homes adding kitchen islands, Nest thermostats, USB ports, garden tubs, or private outdoor space. Browse current availability, explore <a href=\"/gallery\">apartment photos</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the finish.</strong> Browse the Celsius Apartment Homes photo gallery for a closer look at the textures, light, and spaces that shape everyday living in Charlotte. See kitchens with sleek counters, tile backsplashes, and cabinetry that gives the room a polished frame, then move into open living areas where tall ceilings and wide windows make each layout feel bright and easy to personalize.</p><p>Outside, the camera lingers on the pool deck, outdoor lounges, fire pit, and clubhouse spaces designed for a change of pace without leaving home. You can also preview fitness areas, game-room details, and pet-friendly spaces before exploring more <a href=\"/amenities\">community features</a> or stepping through the property with <a href=\"/virtual-tours\">virtual tours</a>.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your spot in Northlake.</strong> Use the interactive map to explore available apartments at Celsius and see how close everyday shopping, dining, errands, and Charlotte-area connections are from your front door.</p>",
  "property_pets_blurb": "<p><strong>Four paws feel considered here.</strong> At Celsius Apartment Homes, your pet routine gets easier from the moment you step outside: let your dog stretch out at the on-site bark park, then rinse off after rainy romps or park days at the posh pet spa. Inside, in-home washer and dryer and easy-care finishes help keep daily messes manageable, while select private outdoor spaces add a little fresh-air pause between walks.</p><p>For cats, dogs, and the people who care for them, this pet-friendly apartment community in Charlotte keeps essentials close, too, with pet supplies, grooming, training, and veterinary care available nearby along Perimeter Parkway. Browse more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Celsius fits life with your companion.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Celsius experience.</strong> Love the modern finishes, room-to-recharge layouts, resort-style pools, fitness spaces, and easy Northlake access? Invite a friend to take a look and help them find their next one-, two-, or three-bedroom home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made easy.</strong> Settle into modern Northlake living with the everyday convenience Celsius is known for. Log in to pay rent, submit maintenance requests, and manage your account—all in one simple place, so home stays polished, connected, and easy to maintain.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying about Celsius Apartment Homes.</strong> Reviews highlight a responsive leasing team, clear communication, and the everyday ease of living in a well-maintained community in Wedgewood.</p><p>Residents especially call out team members who are “kind and helpful,” stay in touch, and handle questions or concerns quickly. Others point to the peaceful environment, convenient setting, and a community experience that continues to feel positive year after year. As one resident shared, the team members “go above and beyond to make you feel at home.”</p>",
  "property_created_at": "1752256650282",
  "property_scheduletour_blurb": "<p><strong>See Celsius in person.</strong> Tour polished one-, two-, and three-bedroom apartment homes with keyless entry, Nest thermostats, tall ceilings, in-home laundry, and select private outdoor space—then explore the pools, fitness centers, clubhouses, and work-from-home spaces that make daily life easier. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Our leasing team will follow up soon. In the meantime, picture modern Northlake living with polished apartment finishes, flexible one-, two-, and three-bedroom layouts, and community spaces designed to make daily life easier at Celsius Apartment Homes.</p>",
  "property_virtualtours_blurb": "<p><strong>Step into the community before you arrive.</strong> The Celsius Apartments - Community Tour lets you explore the shared spaces that shape everyday living here, from polished lounge areas and clubhouse details to the resort-style pool atmosphere and places to recharge between plans. Move through the experience at your own pace, zoom in on finishes, and get a better sense of how the community feels beyond still photos.</p><p>Use the virtual tour as your first look, then compare it with the <a href=\"/gallery\">photo gallery</a> or browse <a href=\"/amenities\">community amenities</a> to connect each space with the features that matter most to your routine. When you’re ready to see Celsius Apartment Homes in person, <a href=\"/schedule-a-tour\">schedule a tour</a> with the leasing team.</p>",
  "property_copyright": "2025 All Rights Reserved. Celsius Apartment Homes",
  "property_seo_title_home": "Celsius Apartment Homes | Apartments in Charlotte, NC",
  "property_seo_description_home": "Discover your perfect sanctuary at Celsius Apartment Homes in vibrant Charlotte, NC! Choose from spacious one, two, and three-bedroom floor plans designed for your lifestyle. Enjoy exceptional amenities including a sparkling pool, state-of-the-art fitness center, dog park, and cozy clubhouse. With features like smart locks, tall ceilings, and luxury finishes, every detail caters to your comfort. Experience convenience with our LUXER Package Locker, online resident services, and modern kitchen appliances. Don't wait—find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Charlotte, NC",
  "property_seo_description_floorplans": "Discover your ideal living space at Celsius Apartment Homes in Charlotte, NC! Our diverse floor plans include stylish one, two, and three-bedroom apartments designed to fit your lifestyle. Browse our available apartment homes today and find the perfect layout that meets your needs. Your new home awaits!",
  "property_seo_title_amenities": "Amenities | Charlotte, NC Apartments for Rent",
  "property_seo_description_amenities": "Discover the perfect blend of luxury and convenience at Celsius Apartment Homes in Charlotte, NC. Choose from our stylish one, two, and three-bedroom floor plans, featuring modern kitchens, smart locks, and USB outlets. Enjoy resort-style amenities like a sparkling pool, fitness center, dog park, and a cozy clubhouse with a coffee bar. Plus, take advantage of our LUXER package lockers and online resident services. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Charlotte, NC",
  "property_seo_description_gallery": "Explore life at Celsius Apartment Homes in Charlotte, NC! Our stunning one, two, and three-bedroom floor plans offer luxurious amenities including a fitness center, resort-style pool, and dog spa. Enjoy modern conveniences such as smart locks, USB outlets, and online resident services in select units featuring balconies, garden tubs, and tall ceilings. Picture yourself in our vibrant community with welcoming spaces like the clubhouse and coffee bar. Experience the perfect blend of comfort and style—your new home awaits! Visit our photo gallery today!",
  "property_seo_title_virtualtours": "Virtual Tours | Celsius Apartment Homes Apartments",
  "property_seo_description_virtualtours": "Explore Celsius Apartment Homes in Charlotte, NC! Discover our variety of stylish one, two, and three-bedroom floor plans, designed to fit your lifestyle. Take a virtual tour of our beautiful community and find your perfect apartment for rent today! Don't miss out—experience luxury living at its finest.",
  "property_seo_title_interactivemap": "Interactive Map | Celsius Apartment Homes Apartments",
  "property_seo_description_interactivemap": "Discover your perfect sanctuary at Celsius Apartment Homes in vibrant Charlotte, NC! Choose from spacious one, two, or three-bedroom floor plans with luxury amenities including a state-of-the-art fitness center, dog park, pool with scenic views, and a clubhouse with a coffee bar. Relax by the fire pit, enjoy eco-friendly living with a recycling center, and benefit from our convenient LUXER package locker. Explore select homes featuring smart locks, digital thermostats, and designer kitchens. Use our interactive community map to find available apartments, view pricing, and envision your new life today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Charlotte, NC",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Celsius Apartment Homes in Charlotte, NC! Explore our one, two, and three-bedroom floor plans and see what's around our community. Dive into local favorites and nearby points of interest—your ideal lifestyle is just a click away!",
  "property_seo_title_contact": "Contact Us | Celsius Apartment Homes",
  "property_seo_description_contact": "Discover your ideal living space at Celsius Apartment Homes in Charlotte, NC! Explore our diverse floor plans, including one, two, and three-bedroom options, designed to fit your lifestyle. Have questions? Contact our leasing team today to learn more about our community and schedule a tour!",
  "property_seo_title_faqs": "FAQs | Apartments in Charlotte, NC",
  "property_seo_description_faqs": "Discover your ideal living space at Celsius Apartment Homes in Charlotte, NC! Explore our diverse floor plans, including one, two, and three-bedroom options, tailored to fit your lifestyle. Enjoy top-notch amenities such as a fitness center, pool, dog park, and clubhouse, plus modern features like smart locks and USB outlets. Have questions? Browse our FAQs page for answers and learn more about our vibrant community today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Charlotte, NC",
  "property_seo_description_reviews": "Discover the vibrant lifestyle at Celsius Apartment Homes in Charlotte, NC! Explore our spacious one, two, and three-bedroom floor plans and indulge in top-tier amenities like a refreshing pool, fitness center, dog park, and clubhouse. With convenient features like digital thermostats, smart locks, and online resident services, comfort meets convenience. Don’t just take our word for it—see what our residents have to say about living in this exceptional community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Charlotte, NC",
  "property_seo_description_applynow": "Discover your ideal living space at Celsius Apartment Homes in Charlotte, NC! Choose from spacious one, two, or three-bedroom floor plans, each featuring modern amenities like a pool, fitness center, and dog spa. Enjoy the convenience of smart locks, digital thermostats, and online resident services. Embrace a lifestyle of comfort and community—apply now and find your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Celsius Apartment Homes",
  "property_seo_description_residentaccess": "\"Log in to your resident portal at Celsius Apartment Homes in Charlotte, NC! Manage your account, pay rent, schedule maintenance, and enjoy seamless community living—all in one place. Access your resident services today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Celsius Apartment Homes",
  "property_seo_description_referafriend": "\"Share the love of Celsius Apartment Homes in Charlotte, NC! Refer a friend today and turn great friends into great neighbors. Discover our vibrant community, modern amenities, and exclusive rewards for referrals. Join us in making Celsius your perfect home!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Celsius Apartment Homes",
  "property_seo_description_scheduletour": "Discover your new home at Celsius Apartment Homes in vibrant Charlotte, NC! Explore our stunning community and find the perfect apartment for your lifestyle. Schedule a tour today to experience modern living, top-notch amenities, and exceptional service!",
  "property_seo_title_privacy": "Privacy Policy | Celsius Apartment Homes",
  "property_seo_description_privacy": "\"Discover how Celsius Apartment Homes in Charlotte, NC safeguards your privacy. Our Privacy Policy outlines the measures we take to protect your data and ensure a secure living experience. View our privacy policy today to learn more!\"",
  "property_seo_title_accessibility": "Website Accessibility | Celsius Apartment Homes",
  "property_seo_description_accessibility": "\"Discover Celsius Apartment Homes in Charlotte, NC, where we prioritize digital inclusion and accessibility for all. Explore our commitment to creating an inclusive living environment. Read our Accessibility Statement today!\"",
  "property_seo_title_sitemap": "Sitemap | Celsius Apartment Homes",
  "property_seo_description_sitemap": "Discover the ultimate living experience at Celsius Apartment Homes in Charlotte, NC! Explore our sitemap to find detailed information about our modern amenities, floor plans, and nearby attractions. Navigate effortlessly and take the first step toward your new home today!",
  "property_seo_title_thankyou": "Thank You | Celsius Apartment Homes",
  "property_seo_description_thankyou": "\"Thank you for your interest in Celsius Apartment Homes in Charlotte, NC! Your submission has been received, and a member of our friendly team will reach out to you shortly. Discover your new home, where comfort meets convenience. Stay tuned for updates!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319669",
  "amenities": [
    {
      "id": "custom_bdf87d80-3556-4459-9c01-f941ca5e8b19",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_535cc9fa-ef22-42a0-8d13-98e63b0fb6b5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9d208e46-01d4-41e0-9304-b8e4daf283ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000602",
      "title": "Billiards",
      "amount": "0.0000",
      "description": "Billiards & Game Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_244f30d0-e92e-4abf-b7e7-8270fec1b382",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Designer Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cd220585-ac36-4e46-a3ab-4e5f1ff5d6c1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000611",
      "title": "Car Wash",
      "amount": "0.0000",
      "description": "Community Car Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_708a22ca-c93e-4ccd-825b-2266d7718b19",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000614",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Two Clubhouses w/ Business Centers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ce07222-6858-43bc-bc19-cd18d818ea94",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000615",
      "title": "Coffee Bar",
      "amount": "0.0000",
      "description": "Gourmet Coffee Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_23eca9c3-0844-476c-82e9-6fc5413aedd4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Quartz or Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_27f9539b-f5af-4975-ab53-dbbf3a918632",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000625",
      "title": "Digital Thermostats",
      "amount": "0.0000",
      "description": "NEST Thermostats",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_638adfab-7845-4b6b-81f0-918dcfacaab2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_197cd5d4-230d-4919-aa1a-da3023a0d81b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000627",
      "title": "Dog Spa",
      "amount": "0.0000",
      "description": "Posh Pet Spa",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d4ce2b83-db07-43f7-b821-db1a14adc8e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000634",
      "title": "Fire Pit",
      "amount": "0.0000",
      "description": "Firepit & Outdoor Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b406edbf-21a6-4957-b410-0c499f1b64d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Two Modern 24-Hour Fitness Centers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_91f98961-605e-4a6a-a482-4ac5e29a0214",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Garages & Storage Space Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0eb811c7-5715-4f47-8cb3-c670f8a96080",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000641",
      "title": "Garden Tub",
      "amount": "0.0000",
      "description": "Tile Surrounded Garden Tubs*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9160224c-7f44-410c-a00c-383606f3b1e2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_248c748e-7120-4920-b9ad-19e0825db346",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000652",
      "title": "Kitchen Islands",
      "amount": "0.0000",
      "description": "Kitchen Island*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_17caff79-cdf0-4465-9665-5bcce8a85f36",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e2cf9ad8-533b-4ecf-85ba-aae88839a78f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eb0b10aa-b8f3-4fa6-862d-af815a3d5c6a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "2 Resort-Inspired Pool w/Sundecks",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f687f741-e691-4777-a7f1-9f1fa3a8052c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000670",
      "title": "Recycling Center",
      "amount": "0.0000",
      "description": "Resident Recycling Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b4ea8dd1-d17b-4d79-b3a9-de4beccacd15",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cf7d8b91-4d04-47d2-a2f2-b094b85fa680",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9` or 10' Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e2fbe25a-55c3-41aa-8618-7f91b8f599e1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Subway Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_382cfc96-7797-46e2-8af2-583c42c54efd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "USB Ports*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5de763dc-f66a-41d5-b673-abc57a0de7d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5bd67c49-48bf-4f30-8f4d-26660797c3f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "external_id": "P000000708",
      "title": "Wifi",
      "amount": "0.0000",
      "description": "Wifi Available in Community Areas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a9479b81-922a-4fd9-807e-ec693c7ab49a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-913d-74ed-a0ea-ef88d72bb5e8.webp",
      "image_media": {
        "alt_text": "View into a bedroom with a king-size bed and decorative wall art.",
        "public_id": "019e898a-913d-74ed-a0ea-ef88d72bb5e8",
        "storage_key": "property/5734243929948160/019e898a-913d-74ed-a0ea-ef88d72bb5e8.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush king-size bed and tasteful decor.",
      "link": "",
      "alt_text": "View into a bedroom with a king-size bed and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_708226b2-b099-4d95-b7cf-65f559e4b20a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-96d8-73db-8048-449a241aea01.webp",
      "image_media": {
        "alt_text": "Well-equipped gym with squat racks, weight benches, rowing machines, and exercise bikes.",
        "public_id": "019e898a-96d8-73db-8048-449a241aea01",
        "storage_key": "property/5734243929948160/019e898a-96d8-73db-8048-449a241aea01.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring everything you need for a complete workout, from free weights to cardio machines.",
      "link": "",
      "alt_text": "Well-equipped gym with squat racks, weight benches, rowing machines, and exercise bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3f8b2a49-2866-43f9-9f58-715f410b73a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-9a47-769b-99fc-049230908b90.webp",
      "image_media": {
        "alt_text": "Modern game room with arcade games, gaming chairs, and a large screen TV showing a soccer game.",
        "public_id": "019e898a-9a47-769b-99fc-049230908b90",
        "storage_key": "property/5734243929948160/019e898a-9a47-769b-99fc-049230908b90.webp",
        "width": 1076,
        "height": 717
      },
      "title": "Community",
      "description": "Unwind and challenge your friends in our state-of-the-art game room, featuring arcade classics and high-tech gaming stations. A perfect space for relaxation and fun.",
      "link": "",
      "alt_text": "Modern game room with arcade games, gaming chairs, and a large screen TV showing a soccer game.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6a69cdf4-b9ca-4490-b36c-43aa933c9e94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-8d34-73df-a133-697e66a3da38.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and hot tub with fountains and lounge chairs.",
        "public_id": "019e898a-8d34-73df-a133-697e66a3da38",
        "storage_key": "property/5734243929948160/019e898a-8d34-73df-a133-697e66a3da38.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool or relax in the soothing hot tub. Lounge chairs and fountains create a serene oasis.",
      "link": "",
      "alt_text": "Outdoor swimming pool and hot tub with fountains and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e13df08b-5481-4dd8-904e-941bc7011bf1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-875c-75bb-8b50-26b93ffed98a.webp",
      "image_media": {
        "alt_text": "Stylish seating area with sofas, glass coffee tables, and a coffee station in a modern apartment building lobby.",
        "public_id": "019e898a-875c-75bb-8b50-26b93ffed98a",
        "storage_key": "property/5734243929948160/019e898a-875c-75bb-8b50-26b93ffed98a.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and recharge in our beautifully designed resident lounge, featuring comfortable seating and a convenient coffee bar. A perfect space to unwind or socialize.",
      "link": "",
      "alt_text": "Stylish seating area with sofas, glass coffee tables, and a coffee station in a modern apartment building lobby.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ae48c88-d0f0-4fc9-8f9f-28bce4fc14d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-8421-762a-87ad-964ae40f882f.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with seating and umbrellas near a swimming pool and apartment buildings.",
        "public_id": "019e898a-8421-762a-87ad-964ae40f882f",
        "storage_key": "property/5734243929948160/019e898a-8421-762a-87ad-964ae40f882f.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at the community's outdoor kitchen and lounge area, complete with grills and comfortable seating, located steps from the sparkling pool.",
      "link": "",
      "alt_text": "Outdoor grilling area with seating and umbrellas near a swimming pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aa4a5b06-2759-46ec-a0c6-54ac7a71c52a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-7e10-7404-a397-ed7b0cf43a14.webp",
      "image_media": {
        "alt_text": "Spinning bikes and weights in a modern fitness center.",
        "public_id": "019e898a-7e10-7404-a397-ed7b0cf43a14",
        "storage_key": "property/5734243929948160/019e898a-7e10-7404-a397-ed7b0cf43a14.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines, weights, and a dedicated yoga space.",
      "link": "",
      "alt_text": "Spinning bikes and weights in a modern fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f55ed0d8-28cc-40e3-bb40-06e04cd41b13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-814b-711a-867f-537931712e3e.webp",
      "image_media": {
        "alt_text": "Ping pong table and dartboard in a modern community lounge.",
        "public_id": "019e898a-814b-711a-867f-537931712e3e",
        "storage_key": "property/5734243929948160/019e898a-814b-711a-867f-537931712e3e.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy recreation and socializing in the community lounge, featuring a ping pong table and dartboard.",
      "link": "",
      "alt_text": "Ping pong table and dartboard in a modern community lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b676322d-5229-4364-9269-7e2f75d42c75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-806b-719c-aac2-a773efcbe8dc.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and mirror. Bedroom visible through doorway.",
        "public_id": "019e898a-806b-719c-aac2-a773efcbe8dc",
        "storage_key": "property/5734243929948160/019e898a-806b-719c-aac2-a773efcbe8dc.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into comfort with this well-appointed bathroom, featuring a stylish vanity and spacious bedroom views. Perfect for unwinding.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and mirror. Bedroom visible through doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6ca64986-8e27-4ab4-bd65-f1620a8ee908",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-7d8c-761a-8a04-70c2a238f420.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge chairs in an apartment complex courtyard.",
        "public_id": "019e898a-7d8c-761a-8a04-70c2a238f420",
        "storage_key": "property/5734243929948160/019e898a-7d8c-761a-8a04-70c2a238f420.webp",
        "width": 2597,
        "height": 1730
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Swimming pool and lounge chairs in an apartment complex courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6e1146a-717a-4a26-a798-c3113795c958",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-7cc5-749c-b455-15a68f84de64.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wooden cabinets.",
        "public_id": "019e898a-7cc5-749c-b455-15a68f84de64",
        "storage_key": "property/5734243929948160/019e898a-7cc5-749c-b455-15a68f84de64.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring stainless steel appliances, ample cabinet space, and elegant granite countertops for a sophisticated cooking experience.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5dfa3ba0-1007-4103-bcc0-78cc83b0d549",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-7ad3-730c-bcee-19fde56b4d76.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with a granite countertop, dark wood vanity, white bathtub, and white tiled shower walls.",
        "public_id": "019e898a-7ad3-730c-bcee-19fde56b4d76",
        "storage_key": "property/5734243929948160/019e898a-7ad3-730c-bcee-19fde56b4d76.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into this stylish apartment bathroom featuring a sleek granite countertop, rich dark wood vanity, and a pristine white bathtub with tiled shower walls.",
      "link": "",
      "alt_text": "Modern apartment bathroom with a granite countertop, dark wood vanity, white bathtub, and white tiled shower walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e0e041b4-99f4-4bf8-867a-2f24f190ca24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-70ed-73c4-9717-b1a818a875d7.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit and lounge chairs next to a swimming pool and apartment buildings.",
        "public_id": "019e898a-70ed-73c4-9717-b1a818a875d7",
        "storage_key": "property/5734243929948160/019e898a-70ed-73c4-9717-b1a818a875d7.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax by the fire pit or take a dip in the pool. This outdoor community space offers the perfect spot to unwind and enjoy the outdoors.",
      "link": "",
      "alt_text": "Outdoor seating area with a fire pit and lounge chairs next to a swimming pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ca3a7b60-ae4f-49ea-b74d-426b5f8d127a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-7182-77e4-9992-814d7073867d.webp",
      "image_media": {
        "alt_text": "Billiard table in a common area with computers and lounge seating.",
        "public_id": "019e898a-7182-77e4-9992-814d7073867d",
        "storage_key": "property/5734243929948160/019e898a-7182-77e4-9992-814d7073867d.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a game of billiards in the community's game room, complete with computers and comfortable seating.",
      "link": "",
      "alt_text": "Billiard table in a common area with computers and lounge seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_28ef56f2-66f7-43da-ad17-403b6d6bda99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-6f9b-74bc-aabb-582762d52843.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood cabinets.",
        "public_id": "019e898a-6f9b-74bc-aabb-582762d52843",
        "storage_key": "property/5734243929948160/019e898a-6f9b-74bc-aabb-582762d52843.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience the convenience and style of our apartment kitchens, featuring stainless steel appliances, elegant granite countertops, and ample wood cabinetry.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c6434d4-32db-46d9-9b26-8c52ce9c7adf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-6251-7729-9a74-0e202872adf5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with warm wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019e898a-6251-7729-9a74-0e202872adf5",
        "storage_key": "property/5734243929948160/019e898a-6251-7729-9a74-0e202872adf5.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience culinary delights in this stylish kitchen, featuring elegant wood cabinetry, sleek granite countertops, and top-of-the-line stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with warm wood cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8b048954-8f53-4d75-8e43-4677b8cf6e85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-5699-709f-9697-6358f2a47fed.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with seating, grills, and pool in the background.",
        "public_id": "019e898a-5699-709f-9697-6358f2a47fed",
        "storage_key": "property/5734243929948160/019e898a-5699-709f-9697-6358f2a47fed.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and entertain in our stylish outdoor lounge area, featuring comfortable seating, built-in grills, and a sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor lounge area with seating, grills, and pool in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8dce1298-4b58-41b5-a846-469972eeb2cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-6997-768a-a14b-8586efdae86e.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelves and hanging rod",
        "public_id": "019e898a-6997-768a-a14b-8586efdae86e",
        "storage_key": "property/5734243929948160/019e898a-6997-768a-a14b-8586efdae86e.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with built-in shelving and a hanging rod, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with shelves and hanging rod",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c20c42d4-e30a-4aaf-95f9-b32f302a80d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-5698-75ed-b393-75f878eb2f70.webp",
      "image_media": {
        "alt_text": "Modern living room with a white sectional sofa, glass coffee table, and dining area.",
        "public_id": "019e898a-5698-75ed-b393-75f878eb2f70",
        "storage_key": "property/5734243929948160/019e898a-5698-75ed-b393-75f878eb2f70.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable white sectional, elegant glass coffee table, and a dining set perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room with a white sectional sofa, glass coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23d72476-2c95-461f-8549-e8bf552eefa5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-53cc-7699-8e11-71d04902f8f8.webp",
      "image_media": {
        "alt_text": "Luxurious swimming pool and hot tub area with lounge chairs and outdoor seating at a multifamily property.",
        "public_id": "019e898a-53cc-7699-8e11-71d04902f8f8",
        "storage_key": "property/5734243929948160/019e898a-53cc-7699-8e11-71d04902f8f8.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our stunning outdoor swimming pool and relaxing hot tub. Perfect for unwinding or entertaining guests.",
      "link": "",
      "alt_text": "Luxurious swimming pool and hot tub area with lounge chairs and outdoor seating at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_711be6ff-78e8-49f3-b276-0978addc8b63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-6036-70c9-a2fb-a20214fcf292.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "019e898a-6036-70c9-a2fb-a20214fcf292",
        "storage_key": "property/5734243929948160/019e898a-6036-70c9-a2fb-a20214fcf292.webp",
        "width": 2732,
        "height": 1820
      },
      "title": "Community",
      "description": "Enjoy our beautiful resort-style swimming pool, perfect for relaxing and soaking up the sun. Surrounded by lush landscaping and comfortable lounge chairs, it's the ideal oasis.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and surrounding buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f8d29dff-a830-41e7-9681-2dcd20745234",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-54c5-757b-97ef-c185e2598412.webp",
      "image_media": {
        "alt_text": "Modern lobby with seating area and bar.",
        "public_id": "019e898a-54c5-757b-97ef-c185e2598412",
        "storage_key": "property/5734243929948160/019e898a-54c5-757b-97ef-c185e2598412.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Welcome to our stylish lobby, featuring comfortable seating, a contemporary bar area, and elegant decor.",
      "link": "",
      "alt_text": "Modern lobby with seating area and bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_866447a9-594f-45fb-86f2-47e1e7dd1d1d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-53e5-713c-96ed-e8fca7e5fabe.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a white bed, grey accent wall, and mirrored nightstand.",
        "public_id": "019e898a-53e5-713c-96ed-e8fca7e5fabe",
        "storage_key": "property/5734243929948160/019e898a-53e5-713c-96ed-e8fca7e5fabe.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush queen-sized bed and elegant decor.",
      "link": "",
      "alt_text": "Modern bedroom with a white bed, grey accent wall, and mirrored nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1bfb6e95-6507-4426-91c0-638dfbffff15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-5112-73c7-9074-a55913b40bb9.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, dumbbells, and exercise equipment.",
        "public_id": "019e898a-5112-73c7-9074-a55913b40bb9",
        "storage_key": "property/5734243929948160/019e898a-5112-73c7-9074-a55913b40bb9.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, free weights, and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with weight machines, dumbbells, and exercise equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60996735-6a53-4e8e-8bec-b8cdcd69006e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-5195-718b-9f84-95e6c1265a95.webp",
      "image_media": {
        "alt_text": "Modern dining and living area with a white sectional sofa, dining table set for four, and a TV.",
        "public_id": "019e898a-5195-718b-9f84-95e6c1265a95",
        "storage_key": "property/5734243929948160/019e898a-5195-718b-9f84-95e6c1265a95.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully furnished apartment, featuring a spacious living area and a modern dining space perfect for entertaining.",
      "link": "",
      "alt_text": "Modern dining and living area with a white sectional sofa, dining table set for four, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_909dcd14-f9d0-48a1-9b98-4cfb3d6a62cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-45c3-769a-a35e-49bbe4476bd2.webp",
      "image_media": {
        "alt_text": "Dining area with a round table set for four, adjacent to a modern kitchen.",
        "public_id": "019e898a-45c3-769a-a35e-49bbe4476bd2",
        "storage_key": "property/5734243929948160/019e898a-45c3-769a-a35e-49bbe4476bd2.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Enjoy elegant dining in this spacious apartment, featuring a stylish dining area perfectly complemented by a modern, fully-equipped kitchen.",
      "link": "",
      "alt_text": "Dining area with a round table set for four, adjacent to a modern kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5d831fde-ea2f-41b1-a9a1-3144275a319a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-46a1-71e9-b4fe-7056202d5793.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e898a-46a1-71e9-b4fe-7056202d5793",
        "storage_key": "property/5734243929948160/019e898a-46a1-71e9-b4fe-7056202d5793.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and the beautiful architecture of our apartment community.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ac2d3927-0c7b-4ab3-80d1-698ad38aa7a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-453e-74d1-aa6c-359239c7c974.webp",
      "image_media": {
        "alt_text": "Resort-style pool with submerged loungers and a covered bar area.",
        "public_id": "019e898a-453e-74d1-aa6c-359239c7c974",
        "storage_key": "property/5734243929948160/019e898a-453e-74d1-aa6c-359239c7c974.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling resort-style pool, featuring submerged loungers perfect for soaking up the sun. Enjoy the convenience of our outdoor bar and grill area for al fresco dining.",
      "link": "",
      "alt_text": "Resort-style pool with submerged loungers and a covered bar area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_459056ba-e5d9-4a75-b152-33f1fb0bf060",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-292f-728d-9021-6265258c38f5.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and outdoor bar.",
        "public_id": "019e898a-292f-728d-9021-6265258c38f5",
        "storage_key": "property/5734243929948160/019e898a-292f-728d-9021-6265258c38f5.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Dive into relaxation at our stunning resort-style pool, complete with a luxurious hot tub, comfortable lounge chairs, and a vibrant outdoor bar area.",
      "link": "",
      "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and outdoor bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8736e931-2802-4078-b424-372b5f1f2da8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-2edc-721d-a401-3eb00610cd97.webp",
      "image_media": {
        "alt_text": "Game room with arcade cabinets, a table, and modern chairs.",
        "public_id": "019e898a-2edc-721d-a401-3eb00610cd97",
        "storage_key": "property/5734243929948160/019e898a-2edc-721d-a401-3eb00610cd97.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy classic arcade games in the community game room, perfect for fun and relaxation.",
      "link": "",
      "alt_text": "Game room with arcade cabinets, a table, and modern chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eb131853-5d0b-4903-8f87-4a11e85682bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-28e7-762e-8c96-e3ddba869782.webp",
      "image_media": {
        "alt_text": "Stylish bar area with stools and a view of the pool and outdoor seating.",
        "public_id": "019e898a-28e7-762e-8c96-e3ddba869782",
        "storage_key": "property/5734243929948160/019e898a-28e7-762e-8c96-e3ddba869782.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a drink at our elegant bar area, featuring comfortable stools and a stunning view of the resort-style pool and lush landscaping.",
      "link": "",
      "alt_text": "Stylish bar area with stools and a view of the pool and outdoor seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0b6f3e88-2906-430f-a240-bf254b4d96e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-28e2-727e-bd8d-f3795c881dac.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and seating area.",
        "public_id": "019e898a-28e2-727e-bd8d-f3795c881dac",
        "storage_key": "property/5734243929948160/019e898a-28e2-727e-bd8d-f3795c881dac.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and a stylish seating area.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d10d83fb-bb74-4dd7-96fc-22d2f8e553b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-287c-74b1-b7cb-a4978a85d748.webp",
      "image_media": {
        "alt_text": "Fully equipped fitness center with rowing machines, air bikes, weight benches, and free weights.",
        "public_id": "019e898a-287c-74b1-b7cb-a4978a85d748",
        "storage_key": "property/5734243929948160/019e898a-287c-74b1-b7cb-a4978a85d748.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment, weight machines, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fully equipped fitness center with rowing machines, air bikes, weight benches, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b5ae570-f50d-4cc7-8794-01dd40339797",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-27af-7655-a9b5-4815d5c1e493.webp",
      "image_media": {
        "alt_text": "Modern lounge area with black armchairs and wood accents, featuring a fireplace and large TVs.",
        "public_id": "019e898a-27af-7655-a9b5-4815d5c1e493",
        "storage_key": "property/5734243929948160/019e898a-27af-7655-a9b5-4815d5c1e493.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, complete with comfortable seating, a fireplace, and entertainment options.",
      "link": "",
      "alt_text": "Modern lounge area with black armchairs and wood accents, featuring a fireplace and large TVs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd9c5e70-0d44-4d8a-98dd-f58d3a4b656f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e898a-2938-708e-b59a-91b9a014dda8.webp",
      "image_media": {
        "alt_text": "Modern lounge area with contemporary seating and a bar with stools.",
        "public_id": "019e898a-2938-708e-b59a-91b9a014dda8",
        "storage_key": "property/5734243929948160/019e898a-2938-708e-b59a-91b9a014dda8.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax in our stylish resident lounge, featuring comfortable seating and a full-service bar perfect for socializing or unwinding.",
      "link": "",
      "alt_text": "Modern lounge area with contemporary seating and a bar with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2c938cb0-8fc1-4e15-8a26-d8abf576fbf1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e8989-92f1-73cb-a0fd-925c0e24c1d6.webp",
      "image_media": {
        "alt_text": "Celsius Apartment Homes monument sign entrance with manicured landscaping.",
        "public_id": "019e8989-92f1-73cb-a0fd-925c0e24c1d6",
        "storage_key": "property/5734243929948160/019e8989-92f1-73cb-a0fd-925c0e24c1d6.webp",
        "width": 2151,
        "height": 1434
      },
      "title": "Community",
      "description": "Welcome to Celsius Apartment Homes, with a beautiful monument sign and lush landscaping at the community entrance.",
      "link": "",
      "alt_text": "Celsius Apartment Homes monument sign entrance with manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ef466ab9-1908-4145-910c-f677424cb22c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e8989-9302-7388-9207-620d4b6bd05f.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with modern seating and a bar.",
        "public_id": "019e8989-9302-7388-9207-620d4b6bd05f",
        "storage_key": "property/5734243929948160/019e8989-9302-7388-9207-620d4b6bd05f.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and socialize in the modern lounge, featuring comfortable seating and a sleek bar area.",
      "link": "",
      "alt_text": "Stylish lounge area with modern seating and a bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_50aef113-5025-4ee6-a595-caa0b12122be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019e8989-9252-779c-8be6-e7649114ab0d.webp",
      "image_media": {
        "alt_text": "Row of townhomes with attached garages and modern architectural features.",
        "public_id": "019e8989-9252-779c-8be6-e7649114ab0d",
        "storage_key": "property/5734243929948160/019e8989-9252-779c-8be6-e7649114ab0d.webp",
        "width": 2186,
        "height": 1456
      },
      "title": "Community",
      "description": "Discover modern living in these spacious townhomes, featuring private attached garages and contemporary exterior designs.",
      "link": "",
      "alt_text": "Row of townhomes with attached garages and modern architectural features.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_204cb0eed6b87fd43121f251",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Firebirds Wood Fired Grill",
      "poi_type": "Restaurants",
      "poi_address": "6801 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Chain restaurant serving steaks, seafood & cocktails in an upscale lodgelike setting.",
      "poi_long_description": "Chain restaurant serving steaks, seafood & cocktails in an upscale lodgelike setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-48b2-727f-a8db-d1f498fd3571.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-48b2-727f-a8db-d1f498fd3571",
        "storage_key": "property/5734243929948160/019f150e-48b2-727f-a8db-d1f498fd3571.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "https://firebirdsrestaurants.com/charlotte-northlake",
      "poi_directions_map_url": "https://maps.google.com/?cid=16779945163724510867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firebirds-wood-fired-grill",
      "poi_latitude": "35.3521893",
      "poi_longitude": "-80.8514732",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-295-1919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0573-72ad-8582-c4b8c8e9c69a",
        "storage_key": "property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnycdKFWmVogRk1ZV8jhX3ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_616ca3434af2f1346cf63a70",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Parry's Pizzeria & Taphouse",
      "poi_type": "Restaurants",
      "poi_address": "6851 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-4ca9-74e9-aa36-2ae69d5131a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-4ca9-74e9-aa36-2ae69d5131a8",
        "storage_key": "property/5734243929948160/019f150e-4ca9-74e9-aa36-2ae69d5131a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4212369487967180468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parrys-pizzeria--taphouse",
      "poi_latitude": "35.3521471",
      "poi_longitude": "-80.85173900000001",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 980-288-4002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0573-72ad-8582-c4b8c8e9c69a",
        "storage_key": "property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTVGuU6qnVogRtFb6MLtXdTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_aa82816715aff50d31d7516e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Showmars Northlake Mall",
      "poi_type": "Restaurants",
      "poi_address": "6801 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Local chain serving gyros, souvlaki & Greek-American fare in a bright, casual setting.",
      "poi_long_description": "Local chain serving gyros, souvlaki & Greek-American fare in a bright, casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-478d-700d-bd85-7b4cff7bc2fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-478d-700d-bd85-7b4cff7bc2fc",
        "storage_key": "property/5734243929948160/019f150e-478d-700d-bd85-7b4cff7bc2fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.showmars.com/?utm_source=google&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=2784878521723453067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "showmars-northlake-mall",
      "poi_latitude": "35.352377",
      "poi_longitude": "-80.85132999999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-921-7775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0573-72ad-8582-c4b8c8e9c69a",
        "storage_key": "property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnycdKFWmVogRi_7wtULgpSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "ec_82867e748911e60e48989490",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "6801 Northlake Mall Dr Ste FC201, Charlotte, NC 28216, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-3e1c-77a6-870c-79fa608e40a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-3e1c-77a6-870c-79fa608e40a3",
        "storage_key": "property/5734243929948160/019f150e-3e1c-77a6-870c-79fa608e40a3.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/nc/northlake-mall-nc?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8271932529379889386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.352232",
      "poi_longitude": "-80.850748",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-596-1211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0573-72ad-8582-c4b8c8e9c69a",
        "storage_key": "property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnycdKFWmVogR6tCvE8_Oy3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_39a6e7d4285af64ca9d3b831",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Sbarro",
      "poi_type": "Restaurants",
      "poi_address": "6801 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Italian fast-food chain offering thin-crust pizza by the slice, plus pastas & salads.",
      "poi_long_description": "Italian fast-food chain offering thin-crust pizza by the slice, plus pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-433f-7076-b173-3820a75e87ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-433f-7076-b173-3820a75e87ee",
        "storage_key": "property/5734243929948160/019f150e-433f-7076-b173-3820a75e87ee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://sbarro.com/locations/NC/CHARLOTTE/Northlake-Mall/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7669642693176797290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sbarro",
      "poi_latitude": "35.3529926",
      "poi_longitude": "-80.8510984",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-597-0776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0573-72ad-8582-c4b8c8e9c69a",
        "storage_key": "property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnycdKFWmVogRaij52GQLcGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_071c26cb0dce757c8ec6daf1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Northlake Mall",
      "poi_type": "Restaurants",
      "poi_address": "6801 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Department stores & name-brand retailers in a modern mall with a movie theater & casual eateries.",
      "poi_long_description": "Department stores & name-brand retailers in a modern mall with a movie theater & casual eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150a-dc7b-73ec-b362-3c1fbe72f46d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-dc7b-73ec-b362-3c1fbe72f46d",
        "storage_key": "property/5734243929948160/019f150a-dc7b-73ec-b362-3c1fbe72f46d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.shopnorthlake.com/?utm_source=google&utm_medium=organic&utm_campaign=GMB&utm_content=SW22_NORLAKE",
      "poi_directions_map_url": "https://maps.google.com/?cid=7112540795624693928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northlake-mall",
      "poi_latitude": "35.352657",
      "poi_longitude": "-80.8511821",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-447-1744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0584-776a-ac8f-8dbefbb31d64",
        "storage_key": "property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlz5hUaqnVogRqCCvdSvStGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_c4ab2cb14d3599fa555b94ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "9309 Center Lake Dr Ste 100, Charlotte, NC 28216, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-48ac-76bf-aa49-d5db3218156c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-48ac-76bf-aa49-d5db3218156c",
        "storage_key": "property/5734243929948160/019f150e-48ac-76bf-aa49-d5db3218156c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/nc/charlotte/9309-center-lake-drive?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=601050&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=17043734593008405845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "35.3497289",
      "poi_longitude": "-80.8544929",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-921-0013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-35bb-70fb-81ad-7b1c92ae75c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-35bb-70fb-81ad-7b1c92ae75c6",
        "storage_key": "property/5734243929948160/019f150f-35bb-70fb-81ad-7b1c92ae75c6.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJv9raAgCnVogRVY1Njk-Ch-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_1518d2fe7915fbf1fae90aec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "9821 Northlake Centre Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-48ac-76bf-aa49-d36da283baae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-48ac-76bf-aa49-d36da283baae",
        "storage_key": "property/5734243929948160/019f150e-48ac-76bf-aa49-d36da283baae.webp",
        "width": 1280,
        "height": 943
      },
      "poi_business_url": "https://locations.chipotle.com/nc/charlotte/9821-northlake-centre-pkwy?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=2939",
      "poi_directions_map_url": "https://maps.google.com/?cid=9245230708673364224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "35.348798",
      "poi_longitude": "-80.85775520000001",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-596-0117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0573-72ad-8582-c4b8c8e9c69a",
        "storage_key": "property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQVNTDP-mVogRAEECoVioTYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_ddb715c54b117774db715628",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "P.F. Chang's",
      "poi_type": "Restaurants",
      "poi_address": "10325 Perimeter Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "Family-friendly chain offering creative takes on Asian fare in a striking space.",
      "poi_long_description": "Family-friendly chain offering creative takes on Asian fare in a striking space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-439c-71a3-8c99-f1ffb4fe8009.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-439c-71a3-8c99-f1ffb4fe8009",
        "storage_key": "property/5734243929948160/019f150e-439c-71a3-8c99-f1ffb4fe8009.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://locations.pfchangs.com/nc/charlotte/10325-perimeter-pkwy.html?utm_source=google_gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=2728926315351601726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pf-changs",
      "poi_latitude": "35.3487839",
      "poi_longitude": "-80.8532274",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-598-1927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0573-72ad-8582-c4b8c8e9c69a",
        "storage_key": "property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm3NjFACnVogRPnK_fAYY3yU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_c83b2157bb35fc99833ba10d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Red Crab - Juicy Seafood",
      "poi_type": "Restaurants",
      "poi_address": "10224 Perimeter Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "Informal restaurant featuring seafood boils and Cajun dishes, plus cocktails and beer.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-4476-713a-8eee-c4a2af44d437.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-4476-713a-8eee-c4a2af44d437",
        "storage_key": "property/5734243929948160/019f150e-4476-713a-8eee-c4a2af44d437.webp",
        "width": 1046,
        "height": 1280
      },
      "poi_business_url": "https://redcrabseafood.com/locations/charlotte-nc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16432876210167127986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-crab---juicy-seafood",
      "poi_latitude": "35.3481675",
      "poi_longitude": "-80.85191999999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 980-226-5001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0573-72ad-8582-c4b8c8e9c69a",
        "storage_key": "property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9Xe0C76nVogRsp_6GNlNDeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_0abc65d4f6fff6cb6d42d5ee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Boiling Pot",
      "poi_type": "Restaurants",
      "poi_address": "7010 Smith Corners Blvd F, Charlotte, NC 28269, USA",
      "poi_short_description": "Diners select broths, meats, veggies & sauces to cook tableside at this casual Asian restaurant.",
      "poi_long_description": "Diners select broths, meats, veggies & sauces to cook tableside at this casual Asian restaurant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-503b-768d-840a-014b59d8fb7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-503b-768d-840a-014b59d8fb7c",
        "storage_key": "property/5734243929948160/019f150e-503b-768d-840a-014b59d8fb7c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.boilingpotnc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12513750546650319068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boiling-pot",
      "poi_latitude": "35.3499931",
      "poi_longitude": "-80.8430355",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-496-9026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0573-72ad-8582-c4b8c8e9c69a",
        "storage_key": "property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfe5S-6enVogR3EjxTNLFqa0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_03373c37ac572d0001f69ae6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Edomae Sushi & Hibachi Grill",
      "poi_type": "Restaurants",
      "poi_address": "9739 Northlake Centre Pkwy J, Charlotte, NC 28216, USA",
      "poi_short_description": "Casual Japanese eatery in a strip mall preparing an array of raw & cooked sushi, plus grilled meals.",
      "poi_long_description": "Casual Japanese eatery in a strip mall preparing an array of raw & cooked sushi, plus grilled meals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-4f48-755d-b5e1-e3936fcafd1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-4f48-755d-b5e1-e3936fcafd1d",
        "storage_key": "property/5734243929948160/019f150e-4f48-755d-b5e1-e3936fcafd1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://edomaeclt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5813506532595734129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edomae-sushi--hibachi-grill",
      "poi_latitude": "35.3481057",
      "poi_longitude": "-80.8590947",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-596-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0573-72ad-8582-c4b8c8e9c69a",
        "storage_key": "property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD23p_v6mVogRcRbI3mO5rVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_321f3d52cf552e28ae612a94",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "8225 Northlake Commons Blvd, Charlotte, NC 28216, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-546c-7020-a5d8-746b815bedf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-546c-7020-a5d8-746b815bedf8",
        "storage_key": "property/5734243929948160/019f150e-546c-7020-a5d8-746b815bedf8.webp",
        "width": 1280,
        "height": 974
      },
      "poi_business_url": "https://www.olivegarden.com/locations/nc/charlotte/northlake-commons/1682?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:charlotte-nc-1682_pl:locurl_rd:1534",
      "poi_directions_map_url": "https://maps.google.com/?cid=14746984863310385657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "35.348419",
      "poi_longitude": "-80.854616",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-494-4473",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0573-72ad-8582-c4b8c8e9c69a",
        "storage_key": "property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmVod3P-mVogR-ZGtrZnQp8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_8d5987f5949f4bcd10a3b9fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "TGI Fridays",
      "poi_type": "Restaurants",
      "poi_address": "6840 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Casual chain restaurant with a festive vibe serving beer, cocktails & a wide menu of American fare.",
      "poi_long_description": "Casual chain restaurant with a festive vibe serving beer, cocktails & a wide menu of American fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-5ea7-71ac-828e-05dc66a5fa9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-5ea7-71ac-828e-05dc66a5fa9b",
        "storage_key": "property/5734243929948160/019f150e-5ea7-71ac-828e-05dc66a5fa9b.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://locations.tgifridays.com/nc/charlotte/6840-northlake-mall-dr.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5351811441172419308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tgi-fridays",
      "poi_latitude": "35.3494146",
      "poi_longitude": "-80.85131969999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-596-2869",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0573-72ad-8582-c4b8c8e9c69a",
        "storage_key": "property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh9jThQCnVogR7BL0jyZ0RUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_4a37af56fbbc9db5aabc9ce9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "9841 Northlake Centre Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-6f5c-7755-824c-624772864ff1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-6f5c-7755-824c-624772864ff1",
        "storage_key": "property/5734243929948160/019f150e-6f5c-7755-824c-624772864ff1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/charlotte-north/2080",
      "poi_directions_map_url": "https://maps.google.com/?cid=5058957438069124228&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.35013190000001",
      "poi_longitude": "-80.859703",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-526-3648",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0584-776a-ac8f-8dbefbb31d64",
        "storage_key": "property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfb1fRv-mVogRhCzuhfwGNUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_680705cb3d928956c4f6c316",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "9841 Northlake Centre Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-5c34-740a-96a9-f642786d4ccc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-5c34-740a-96a9-f642786d4ccc",
        "storage_key": "property/5734243929948160/019f150e-5c34-740a-96a9-f642786d4ccc.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/charlotte-nc-pharmacies/9841-northlake-centre-pkwy-charlotte-nc-28216/storeid=17168?WT.mc_id=LS_GOOGLE_RX_17168",
      "poi_directions_map_url": "https://maps.google.com/?cid=11852881595992310542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.3502758",
      "poi_longitude": "-80.8600922",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-526-3649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-35c5-73d8-88cd-c2aa59a0f874.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-35c5-73d8-88cd-c2aa59a0f874",
        "storage_key": "property/5734243929948160/019f150f-35c5-73d8-88cd-c2aa59a0f874.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfb1fRv-mVogRDgPjJQPlfaQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_b5d9561c8e1a4ef5b8a7255b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "9220 Northlake W Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Quick-visit convenience store selling gas, coffee, and chicken wings, plus a restroom.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-2ff2-736a-8d81-d72cd1b53a76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-2ff2-736a-8d81-d72cd1b53a76",
        "storage_key": "property/5734243929948160/019f150f-2ff2-736a-8d81-d72cd1b53a76.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.7-eleven.com/locations/nc/charlotte/9220-northlake-west-dr-38677?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=12031725980962673405&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "35.34659",
      "poi_longitude": "-80.8586",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 662-607-5556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-35be-74dc-8dae-afcc9087d0e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-35be-74dc-8dae-afcc9087d0e5",
        "storage_key": "property/5734243929948160/019f150f-35be-74dc-8dae-afcc9087d0e5.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJhcldFPSnVogR_VIeaghH-aY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_0ee41df83b6ec877c78de24d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Northlake Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "6801 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Department stores & name-brand retailers in a modern mall with a movie theater & casual eateries.",
      "poi_long_description": "Department stores & name-brand retailers in a modern mall with a movie theater & casual eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150a-dc7b-73ec-b362-3c1fbe72f46d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-dc7b-73ec-b362-3c1fbe72f46d",
        "storage_key": "property/5734243929948160/019f150a-dc7b-73ec-b362-3c1fbe72f46d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.shopnorthlake.com/?utm_source=google&utm_medium=organic&utm_campaign=GMB&utm_content=SW22_NORLAKE",
      "poi_directions_map_url": "https://maps.google.com/?cid=7112540795624693928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northlake-mall",
      "poi_latitude": "35.352657",
      "poi_longitude": "-80.8511821",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-447-1744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0584-776a-ac8f-8dbefbb31d64",
        "storage_key": "property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlz5hUaqnVogRqCCvdSvStGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_293dade36b1449d314307354",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "10221 Perimeter Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-67e2-749b-9775-4f72e5fdf23a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-67e2-749b-9775-4f72e5fdf23a",
        "storage_key": "property/5734243929948160/019f150e-67e2-749b-9775-4f72e5fdf23a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.bestbuy.com/nc/charlotte/10221-perimeter-pkwy-1155.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=6008536201366436058&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "35.347786",
      "poi_longitude": "-80.852893",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-598-0172",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0584-776a-ac8f-8dbefbb31d64",
        "storage_key": "property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHY2bNQCnVogR2niFLtebYlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "ec_9b016298c34bb89c89ec9da2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "10245 Perimeter Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-727d-71f0-b2e8-89e03a886607.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-727d-71f0-b2e8-89e03a886607",
        "storage_key": "property/5734243929948160/019f150e-727d-71f0-b2e8-89e03a886607.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.petsmart.com/stores/us/nc/charlotte-store1510.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=8245059190044023173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "35.3469924",
      "poi_longitude": "-80.85421749999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-599-0475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0584-776a-ac8f-8dbefbb31d64",
        "storage_key": "property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5_8-L_6mVogRhdmkLqZVbHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_f3d5650d5dd150702eeed052",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Michaels",
      "poi_type": "Shopping & Retail",
      "poi_address": "Perimeter Woods Shopping Center, 10239 Perimeter Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_long_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-685f-703f-befc-08dbe0ceb74d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-685f-703f-befc-08dbe0ceb74d",
        "storage_key": "property/5734243929948160/019f150e-685f-703f-befc-08dbe0ceb74d.webp",
        "width": 1192,
        "height": 791
      },
      "poi_business_url": "https://locations.michaels.com/NC/Charlotte/1386/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=6337098214271138979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "michaels",
      "poi_latitude": "35.3473575",
      "poi_longitude": "-80.85412529999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-970-0071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0584-776a-ac8f-8dbefbb31d64",
        "storage_key": "property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJrTNNLRWnVogRo7xkIEDl8Vc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_bf4ec8e3088a40ae23d585a8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "10235 Perimeter Pkwy Ste A, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-7dd0-73ea-8c70-aa09c948b60b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-7dd0-73ea-8c70-aa09c948b60b",
        "storage_key": "property/5734243929948160/019f150e-7dd0-73ea-8c70-aa09c948b60b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.burlington.com/stores/nc/charlotte/1566?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7978577438893559656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "35.347476",
      "poi_longitude": "-80.853869",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 980-470-4869",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0584-776a-ac8f-8dbefbb31d64",
        "storage_key": "property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk_hhZp6nVogRaE8yiuiZuW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_b1db71aa813c7c34717b9883",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "REI",
      "poi_type": "Shopping & Retail",
      "poi_address": "9755 Northlake Centre Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "Retail chain carrying gear, apparel & footwear for a wide range of outdoor & fitness activities.",
      "poi_long_description": "Retail chain carrying gear, apparel & footwear for a wide range of outdoor & fitness activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-7b20-758c-98e4-bc77a49594e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-7b20-758c-98e4-bc77a49594e7",
        "storage_key": "property/5734243929948160/019f150e-7b20-758c-98e4-bc77a49594e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rei.com/stores/charlotte?y_source=1_MTQ1MzQ5MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1666553197989100496&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rei",
      "poi_latitude": "35.348022",
      "poi_longitude": "-80.857929",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-921-0320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0584-776a-ac8f-8dbefbb31d64",
        "storage_key": "property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNR_E_P6mVogR0HtuxU3JIBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_98da48c2c18ef9b6876bac1b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "10275 Perimeter Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150a-d925-731e-a855-0b3fc16bd239.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-d925-731e-a855-0b3fc16bd239",
        "storage_key": "property/5734243929948160/019f150a-d925-731e-a855-0b3fc16bd239.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/NC-Charlotte/2352?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2352-_-na-_-0-_-0&y_source=1_MTE4MzgyNy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7582863110227447137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.347396",
      "poi_longitude": "-80.85056800000001",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 704-501-4420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0584-776a-ac8f-8dbefbb31d64",
        "storage_key": "property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVf724QCnVogRYU2FsdK9O2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_98cd48056cffb2828e29bcbc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Hornets Nest Elementary",
      "poi_type": "Education",
      "poi_address": "6700 Beatties Ford Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cmsk12.org/hornetsnestES",
      "poi_directions_map_url": "https://maps.google.com/?cid=1367445054262586435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hornets-nest-elementary",
      "poi_latitude": "35.3245763",
      "poi_longitude": "-80.8653669",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 980-343-6110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-05a3-753f-9ccf-b1a530fecbd8",
        "storage_key": "property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLfeKstymVogRQ6wvJQgk-hI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_7f832f35a6cea64efd08d9dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Oaklawn Language Academy",
      "poi_type": "Education",
      "poi_address": "1810 Oaklawn Ave, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-7760-76fe-b858-114168dfcf78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-7760-76fe-b858-114168dfcf78",
        "storage_key": "property/5734243929948160/019f150e-7760-76fe-b858-114168dfcf78.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10706288590886456338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oaklawn-language-academy",
      "poi_latitude": "35.2511641",
      "poi_longitude": "-80.850267",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 980-343-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-05a3-753f-9ccf-b1a530fecbd8",
        "storage_key": "property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJERia7E2gVogREsyawr9glJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_effd532b4041c701d8ba8f3a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Oakdale Elementary",
      "poi_type": "Education",
      "poi_address": "1825 Oakdale Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cmsk12.org/oakdaleES",
      "poi_directions_map_url": "https://maps.google.com/?cid=3905776072499317547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oakdale-elementary",
      "poi_latitude": "35.3004091",
      "poi_longitude": "-80.896126",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 980-343-6076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-05a3-753f-9ccf-b1a530fecbd8",
        "storage_key": "property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPQqWlVehVogRK8uK7aQaNDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_c3a4cbd03935958980fa16f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "University Park Creative Arts School",
      "poi_type": "Education",
      "poi_address": "2400 Hildebrand St, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-8455-70f3-befe-6593cbea21ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-8455-70f3-befe-6593cbea21ec",
        "storage_key": "property/5734243929948160/019f150e-8455-70f3-befe-6593cbea21ec.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cmsk12.org/universityparkES",
      "poi_directions_map_url": "https://maps.google.com/?cid=8841847105501114712&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-park-creative-arts-school",
      "poi_latitude": "35.2609444",
      "poi_longitude": "-80.85923849999999",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 980-343-5178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-05a3-753f-9ccf-b1a530fecbd8",
        "storage_key": "property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyupMqqhVogRWLG1qRiNtHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_8499f337a0423bad35753c3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Lincoln Heights Montessori School",
      "poi_type": "Education",
      "poi_address": "1900 Newcastle St, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cmsk12.org/lincolnheightsmontessoriES",
      "poi_directions_map_url": "https://maps.google.com/?cid=5014002144845333900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lincoln-heights-montessori-school",
      "poi_latitude": "35.258381",
      "poi_longitude": "-80.8427454",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 980-343-9442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-05a3-753f-9ccf-b1a530fecbd8",
        "storage_key": "property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOf72xVmgVogRjIWNqmJQlUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_86cd9025b1e2bb9bac8f30ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Northwest School of the Arts",
      "poi_type": "Education",
      "poi_address": "1415 Beatties Ford Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-872f-752e-a4ae-dad334aef6f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-872f-752e-a4ae-dad334aef6f3",
        "storage_key": "property/5734243929948160/019f150e-872f-752e-a4ae-dad334aef6f3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cmsk12.org/northwestHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=2299209534361407685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-school-of-the-arts",
      "poi_latitude": "35.2569269",
      "poi_longitude": "-80.8576902",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 980-343-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-05a3-753f-9ccf-b1a530fecbd8",
        "storage_key": "property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKc9NkqyhVogRxZDNx-Nu6B8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_8e6a800804891ea05b477a3d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "West Charlotte High School",
      "poi_type": "Education",
      "poi_address": "2219 Senior Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-7c63-733b-b57f-8d2a06642c7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-7c63-733b-b57f-8d2a06642c7e",
        "storage_key": "property/5734243929948160/019f150e-7c63-733b-b57f-8d2a06642c7e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cmsk12.org/westcharlotteHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=17959732207489396490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-charlotte-high-school",
      "poi_latitude": "35.2662161",
      "poi_longitude": "-80.85977439999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 980-343-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-05a3-753f-9ccf-b1a530fecbd8",
        "storage_key": "property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi4kN6AChVogRCi-MuEnJPfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_cc7e9f24fc9d11391a2056ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Mountain Island Lake Academy",
      "poi_type": "Education",
      "poi_address": "7905 Pleasant Grove Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cmsk12.org/mountainislandlakeacademyES",
      "poi_directions_map_url": "https://maps.google.com/?cid=1304685110963848454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountain-island-lake-academy",
      "poi_latitude": "35.3079519",
      "poi_longitude": "-80.9287336",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 980-343-6948",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-05a3-753f-9ccf-b1a530fecbd8",
        "storage_key": "property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjyCyPImjVogRBsW9JjIsGxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_3a533dae1f8cba6d29378d4c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Cadence Academy Preschool",
      "poi_type": "Education",
      "poi_address": "9206 Reames Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "Daycare center offering infant care and early education programs, plus before- and after-school care, and a summer camp.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-8274-76df-89ba-d2d7879bd8ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-8274-76df-89ba-d2d7879bd8ac",
        "storage_key": "property/5734243929948160/019f150e-8274-76df-89ba-d2d7879bd8ac.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.cadence-education.com/locations/nc/charlotte/719?utm_source=google&utm_medium=local_listing&utm_campaign=local_seo",
      "poi_directions_map_url": "https://maps.google.com/?cid=11405456870896651856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cadence-academy-preschool",
      "poi_latitude": "35.3411012",
      "poi_longitude": "-80.8572865",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-946-7915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-05a3-753f-9ccf-b1a530fecbd8",
        "storage_key": "property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOdhU2_ymVogRUE7VaphSSJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_a7ebbd272ac06ea37cac3632",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "The Growing Years Learning Center-Charlotte",
      "poi_type": "Education",
      "poi_address": "8425 Discovery Ln, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-8a05-76fc-8457-8ab0ad478ace.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-8a05-76fc-8457-8ab0ad478ace",
        "storage_key": "property/5734243929948160/019f150e-8a05-76fc-8457-8ab0ad478ace.webp",
        "width": 540,
        "height": 540
      },
      "poi_business_url": "https://tgykids.com/daycare-locations/charlotte/?y_source=1_Mjc4NzU3NTEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6828964825181951866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-growing-years-learning-center-charlotte",
      "poi_latitude": "35.3087106",
      "poi_longitude": "-80.9273596",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-399-5077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-05a3-753f-9ccf-b1a530fecbd8",
        "storage_key": "property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb8MgbImjVogRepebvFNbxV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_5245a864ffed6c5296804620",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "AMC Northlake 14",
      "poi_type": "Entertainment",
      "poi_address": "7325 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Comfortable theater featuring reclining seats, clean toilets and kind staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-aab5-736b-a45e-bb73f3aa3ca7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-aab5-736b-a45e-bb73f3aa3ca7",
        "storage_key": "property/5734243929948160/019f150e-aab5-736b-a45e-bb73f3aa3ca7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/charlotte/amc-northlake-14?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11641706098324670943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-northlake-14",
      "poi_latitude": "35.353584",
      "poi_longitude": "-80.850346",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-596-2137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-35c6-75fc-a270-0ec9d17eb95c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-35c6-75fc-a270-0ec9d17eb95c",
        "storage_key": "property/5734243929948160/019f150f-35c6-75fc-a270-0ec9d17eb95c.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJb55buKunVogR3wkkGgSmj6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_3c637e1a98e5bf16a02525c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Ballantyne Village",
      "poi_type": "Entertainment",
      "poi_address": "14825 Ballantyne Village Way, Charlotte, NC 28277, USA",
      "poi_short_description": "Open-air mall with service providers & dining options, plus a few retailers & valet parking.",
      "poi_long_description": "Open-air mall with service providers & dining options, plus a few retailers & valet parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-ab29-72f8-b9d0-c2c71fee831c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-ab29-72f8-b9d0-c2c71fee831c",
        "storage_key": "property/5734243929948160/019f150e-ab29-72f8-b9d0-c2c71fee831c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ballantynevillage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2984026863170595701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ballantyne-village",
      "poi_latitude": "35.0538789",
      "poi_longitude": "-80.8513948",
      "poi_miles_from_property": "22.9 mi",
      "poi_walking_minutes": "8 hours 28 mins",
      "poi_biking_minutes": "2 hours 21 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 704-369-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0584-776a-ac8f-8dbefbb31d64",
        "storage_key": "property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK_S8-CidVogRdauBO59kaSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_4c5d2c40120a1aa0c191c9fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "The Bowl at Ballantyne",
      "poi_type": "Entertainment",
      "poi_address": "15119 Bowl St, Charlotte, NC 28277, USA",
      "poi_short_description": "Destination offering a variety of eateries, a park, a stream, and shops, as well as events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-a1bf-755f-b4aa-7ffb387004b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-a1bf-755f-b4aa-7ffb387004b6",
        "storage_key": "property/5734243929948160/019f150e-a1bf-755f-b4aa-7ffb387004b6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thebowlnc.com/?utm_source=2060digital&utm_medium=localseo&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=13769928705673943822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bowl-at-ballantyne",
      "poi_latitude": "35.0578745",
      "poi_longitude": "-80.845811",
      "poi_miles_from_property": "22.7 mi",
      "poi_walking_minutes": "8 hours 21 mins",
      "poi_biking_minutes": "2 hours 18 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0584-776a-ac8f-8dbefbb31d64",
        "storage_key": "property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVY1gNvCdVogRDlsmnDOdGL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_ae712cccb57705d5bf46d4ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "TD Amp Ballantyne",
      "poi_type": "Entertainment",
      "poi_address": "11115 Upper Ave, Charlotte, NC 28277, USA",
      "poi_short_description": "Outdoor music amphitheater also hosting films, at new Ballantyne Reimagined project.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-a80e-774c-88c0-24efbe13f2b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-a80e-774c-88c0-24efbe13f2b2",
        "storage_key": "property/5734243929948160/019f150e-a80e-774c-88c0-24efbe13f2b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tdampballantyne.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14937080725788649588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "td-amp-ballantyne",
      "poi_latitude": "35.0593419",
      "poi_longitude": "-80.8473887",
      "poi_miles_from_property": "22.5 mi",
      "poi_walking_minutes": "8 hours 18 mins",
      "poi_biking_minutes": "2 hours 18 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 704-248-2033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ70J1hOadVogRdGj3sccrS88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_005d435e87720b66aa4d9f6e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "The Olde Mecklenburg Restaurant & Biergarten at Ballantyne",
      "poi_type": "Entertainment",
      "poi_address": "15025 Bowl St, Charlotte, NC 28277, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-ade0-770e-b37b-b4235086dc8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-ade0-770e-b37b-b4235086dc8e",
        "storage_key": "property/5734243929948160/019f150e-ade0-770e-b37b-b4235086dc8e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ombbeer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5238904532443810007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-olde-mecklenburg-restaurant--biergarten-at-ballantyne",
      "poi_latitude": "35.0566421",
      "poi_longitude": "-80.84553489999999",
      "poi_miles_from_property": "22.8 mi",
      "poi_walking_minutes": "8 hours 23 mins",
      "poi_biking_minutes": "2 hours 18 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 984-253-1980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-35cf-7478-b190-6a12d7de8ba5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-35cf-7478-b190-6a12d7de8ba5",
        "storage_key": "property/5734243929948160/019f150f-35cf-7478-b190-6a12d7de8ba5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTT5Io16dVogR10h_VOpTtEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "beer_garden"
    },
    {
      "id": "ec_044d1e4486cf889ec07e70f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Topgolf Charlotte - Southwest",
      "poi_type": "Entertainment",
      "poi_address": "8024 Savoy Corporate Dr, Charlotte, NC 28273, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-97a6-7238-b235-3288c4202a65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-97a6-7238-b235-3288c4202a65",
        "storage_key": "property/5734243929948160/019f150e-97a6-7238-b235-3288c4202a65.webp",
        "width": 1000,
        "height": 677
      },
      "poi_business_url": "https://topgolf.com/us/charlotte/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15291613169624602327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-charlotte---southwest",
      "poi_latitude": "35.1535306",
      "poi_longitude": "-80.9449111",
      "poi_miles_from_property": "18.3 mi",
      "poi_walking_minutes": "6 hours 45 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 704-612-4745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0573-72ad-8582-c4b8c8e9c69a",
        "storage_key": "property/5734243929948160/019f150b-0573-72ad-8582-c4b8c8e9c69a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq3u8zXCZVogR19Yoyii5NtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_9c98a9a74b0d6114cc4ea5a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Discovery Place Science",
      "poi_type": "Entertainment",
      "poi_address": "168 W 6th St, Charlotte, NC 28202, USA",
      "poi_short_description": "Kids' science & tech museum with interactive exhibits, an aquarium, rain forest & IMAX theater.",
      "poi_long_description": "Kids' science & tech museum with interactive exhibits, an aquarium, rain forest & IMAX theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-9bfb-7357-8f18-7f2d2af16fd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-9bfb-7357-8f18-7f2d2af16fd1",
        "storage_key": "property/5734243929948160/019f150e-9bfb-7357-8f18-7f2d2af16fd1.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://discoveryplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8672994214166199027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-place-science",
      "poi_latitude": "35.229441",
      "poi_longitude": "-80.8409271",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-327-2189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0571-774c-a871-23596773e70d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0571-774c-a871-23596773e70d",
        "storage_key": "property/5734243929948160/019f150b-0571-774c-a871-23596773e70d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ-LB1SSgVogR8_pkSkmqXHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_31719dc1e9347a415201b841",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Bechtler Museum of Modern Art",
      "poi_type": "Entertainment",
      "poi_address": "420 S Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "Mid-20th-century modern art displayed in an elegant 4-story building filled with natural light.",
      "poi_long_description": "Mid-20th-century modern art displayed in an elegant 4-story building filled with natural light.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-9e33-704c-8909-cd2fbdd6d30e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-9e33-704c-8909-cd2fbdd6d30e",
        "storage_key": "property/5734243929948160/019f150e-9e33-704c-8909-cd2fbdd6d30e.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://bechtler.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4402061911705097934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bechtler-museum-of-modern-art",
      "poi_latitude": "35.2244822",
      "poi_longitude": "-80.8473279",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-353-9209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0571-774c-a871-23596773e70d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0571-774c-a871-23596773e70d",
        "storage_key": "property/5734243929948160/019f150b-0571-774c-a871-23596773e70d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJvSzQNSmgVogRzpZ1TvxDFz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_87645222cd7ca883330c1362",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Carowinds",
      "poi_type": "Entertainment",
      "poi_address": "North Carolina, USA",
      "poi_short_description": "Seasonal, family-friendly amusement park featuring towering roller coasters, waterslides & more.",
      "poi_long_description": "Seasonal, family-friendly amusement park featuring towering roller coasters, waterslides & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-b4d6-76be-a2a3-7216f16d1c47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-b4d6-76be-a2a3-7216f16d1c47",
        "storage_key": "property/5734243929948160/019f150e-b4d6-76be-a2a3-7216f16d1c47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carowinds.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3638331865982573054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carowinds",
      "poi_latitude": "35.1024013",
      "poi_longitude": "-80.9412735",
      "poi_miles_from_property": "21.6 mi",
      "poi_walking_minutes": "7 hours 58 mins",
      "poi_biking_minutes": "2 hours 12 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 704-588-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVWj3q-PVogR_hngLo7zfTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_4a44804a5b919ce0c6ee0020",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Camp North End",
      "poi_type": "Entertainment",
      "poi_address": "300 Camp Rd, Charlotte, NC 28206, USA",
      "poi_short_description": "Food stalls, public art, shops & events in a complex once used as a car factory & military depot.",
      "poi_long_description": "Food stalls, public art, shops & events in a complex once used as a car factory & military depot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-b749-7699-b97d-6044f234b500.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-b749-7699-b97d-6044f234b500",
        "storage_key": "property/5734243929948160/019f150e-b749-7699-b97d-6044f234b500.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.camp.nc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17937517536155598876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camp-north-end",
      "poi_latitude": "35.2464282",
      "poi_longitude": "-80.8334412",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 980-337-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0584-776a-ac8f-8dbefbb31d64",
        "storage_key": "property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzZ80FEKgVogRHADlfind7vg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_ebea849f1a659e260199725a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Atrium Health Pineville",
      "poi_type": "Health and Wellness",
      "poi_address": "10628 Park Rd, Charlotte, NC 28210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-c04b-737a-8551-71c383293a58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-c04b-737a-8551-71c383293a58",
        "storage_key": "property/5734243929948160/019f150e-c04b-737a-8551-71c383293a58.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-pineville?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=5577615577059717873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-pineville",
      "poi_latitude": "35.0918492",
      "poi_longitude": "-80.8713906",
      "poi_miles_from_property": "20.0 mi",
      "poi_walking_minutes": "7 hours 22 mins",
      "poi_biking_minutes": "1 hour 57 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 704-667-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0572-700b-b086-bdf593d06398.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0572-700b-b086-bdf593d06398",
        "storage_key": "property/5734243929948160/019f150b-0572-700b-b086-bdf593d06398.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJY-mdN1-cVogR8XJU3NCrZ00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_6c0a8d8fb537d7d4bf37e676",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Atrium Health Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "10210 Couloak Dr E, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-b28c-73e9-8e86-10feae0f2d13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-b28c-73e9-8e86-10feae0f2d13",
        "storage_key": "property/5734243929948160/019f150e-b28c-73e9-8e86-10feae0f2d13.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-urgent-care-mountain-island?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=11640727610543668664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-urgent-care",
      "poi_latitude": "35.3242932",
      "poi_longitude": "-80.9477716",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-801-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfZvUBIakVogRuH2JKRYsjKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_9ed9701ac072337ba24581a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "9200 Harris Corners Pkwy K, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-c881-74de-8c94-18e6c605cf96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-c881-74de-8c94-18e6c605cf96",
        "storage_key": "property/5734243929948160/019f150e-c881-74de-8c94-18e6c605cf96.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.concentra.com/?utm_source=Yext&utm_medium=Organic&utm_campaign=Homepage%20Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=16579778217163358186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "35.3471078",
      "poi_longitude": "-80.8440708",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-342-9011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh4UIxXifVogR6v_H8HE0F-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_033bcbc07cf456805808be8b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Marathon Health @ Northlake",
      "poi_type": "Health and Wellness",
      "poi_address": "10216 Perimeter Pkwy c, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-c035-773b-806f-6824df050713.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-c035-773b-806f-6824df050713",
        "storage_key": "property/5734243929948160/019f150e-c035-773b-806f-6824df050713.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://clients.marathon.health/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6415663743744420252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marathon-health--northlake",
      "poi_latitude": "35.347826",
      "poi_longitude": "-80.8517538",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 866-434-3255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD1vbUACnVogRnCk97C4ECVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_be11aaa5b4ee207195a32390",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Synchrony Pharmacy - Charlotte",
      "poi_type": "Health and Wellness",
      "poi_address": "9009 Perimeter Woods Dr K, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.synchronypharmacy.com/?utm_source=google&utm_medium=organic&utm_campaign=gbpcharlotte",
      "poi_directions_map_url": "https://maps.google.com/?cid=17794168234644995086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "synchrony-pharmacy---charlotte",
      "poi_latitude": "35.3430889",
      "poi_longitude": "-80.8513406",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 866-579-3181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-35c5-73d8-88cd-c2aa59a0f874.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-35c5-73d8-88cd-c2aa59a0f874",
        "storage_key": "property/5734243929948160/019f150f-35c5-73d8-88cd-c2aa59a0f874.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6FpJUunVogRDvyNW7uV8fY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_33ddae368e05370f564ef182",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "9841 Northlake Centre Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-5c34-740a-96a9-f642786d4ccc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-5c34-740a-96a9-f642786d4ccc",
        "storage_key": "property/5734243929948160/019f150e-5c34-740a-96a9-f642786d4ccc.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/charlotte-nc-pharmacies/9841-northlake-centre-pkwy-charlotte-nc-28216/storeid=17168?WT.mc_id=LS_GOOGLE_RX_17168",
      "poi_directions_map_url": "https://maps.google.com/?cid=11852881595992310542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.3502758",
      "poi_longitude": "-80.8600922",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-526-3649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-35c5-73d8-88cd-c2aa59a0f874.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-35c5-73d8-88cd-c2aa59a0f874",
        "storage_key": "property/5734243929948160/019f150f-35c5-73d8-88cd-c2aa59a0f874.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfb1fRv-mVogRDgPjJQPlfaQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d8e6ff9ee6232199d690aa91",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "5040 Beatties Ford Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-d306-7695-bf1a-45e450a16d0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-d306-7695-bf1a-45e450a16d0e",
        "storage_key": "property/5734243929948160/019f150e-d306-7695-bf1a-45e450a16d0e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-5040+beatties+ford+rd-charlotte-nc-28216/id=10275",
      "poi_directions_map_url": "https://maps.google.com/?cid=12031644628365451049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.3047104",
      "poi_longitude": "-80.8571932",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-394-1714",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuScYAiuhVogRKZ91CQv9-KY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_2d154ea0014f98a5bef873eb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Fitness Connection",
      "poi_type": "Health and Wellness",
      "poi_address": "8626 Hankins Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150a-ece7-7368-ba0f-159a5bba7661.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-ece7-7368-ba0f-159a5bba7661",
        "storage_key": "property/5734243929948160/019f150a-ece7-7368-ba0f-159a5bba7661.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fitnessconnection.com/gyms/northlake/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1987467375193000770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-connection",
      "poi_latitude": "35.3415059",
      "poi_longitude": "-80.8338327",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-596-9009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxZAF-wynVogRQosONQznlBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f7c4a4243bfa5a21262e9cd3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "QC Fit Northlake",
      "poi_type": "Health and Wellness",
      "poi_address": "8721 Sidney Cir #500, Charlotte, NC 28269, USA",
      "poi_short_description": "Workout hub featuring CrossFit, yoga and mobility fitness classes, plus a supportive community.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-c92a-710a-8118-41a634217980.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-c92a-710a-8118-41a634217980",
        "storage_key": "property/5734243929948160/019f150e-c92a-710a-8118-41a634217980.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.crossfitnorthlake.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2222183777640695892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qc-fit-northlake",
      "poi_latitude": "35.3412137",
      "poi_longitude": "-80.8466978",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-407-8626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGeJJ3wSnVogRVMjoQ1_I1h4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_c5990ae49a47d1b882818165",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Megaflex Gym Northlake",
      "poi_type": "Health and Wellness",
      "poi_address": "3710-B W W.T.Harris Blvd, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-d5eb-7198-9e4f-549810851626.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-d5eb-7198-9e4f-549810851626",
        "storage_key": "property/5734243929948160/019f150e-d5eb-7198-9e4f-549810851626.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.megaflexgym.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6007686669846671793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "megaflex-gym-northlake",
      "poi_latitude": "35.3344994",
      "poi_longitude": "-80.7931204",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 980-237-2270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO8s5xcAdVIgRsXEPNjKXX1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_f68658631233562b6d8002a8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Long Creek Greenway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9841 Northlake Centre Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-dcbe-7762-88a6-363249780174.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-dcbe-7762-88a6-363249780174",
        "storage_key": "property/5734243929948160/019f150e-dcbe-7762-88a6-363249780174.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://publicinput.com/LongCreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=6661960119469705280&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "long-creek-greenway",
      "poi_latitude": "35.349001",
      "poi_longitude": "-80.8604127",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qq5p2mVogRQIjPnG4JdFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_128d21d4c7946e730fed0919",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Ribbonwalk Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4601 Nevin Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Scenic park featuring a large beech tree grove, trails & several species of birds & butterflies.",
      "poi_long_description": "Scenic park featuring a large beech tree grove, trails & several species of birds & butterflies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-e627-7573-8994-494c480b6e4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-e627-7573-8994-494c480b6e4f",
        "storage_key": "property/5734243929948160/019f150e-e627-7573-8994-494c480b6e4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/Nature",
      "poi_directions_map_url": "https://maps.google.com/?cid=10225485868296884956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ribbonwalk-nature-preserve",
      "poi_latitude": "35.2963392",
      "poi_longitude": "-80.8209966",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0572-700b-b086-c03afb396400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0572-700b-b086-c03afb396400",
        "storage_key": "property/5734243929948160/019f150b-0572-700b-b086-c03afb396400.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjeTb0K-gVogR3NKcYzg56I0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_2b7f7526094415ad2d9cd792",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Nevin Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6000 Statesville Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Expansive area features 7 athletic fields, 3 playgrounds, a seasonal sprayground & disc golf course.",
      "poi_long_description": "Expansive area features 7 athletic fields, 3 playgrounds, a seasonal sprayground & disc golf course.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150a-f5e2-7344-bd6b-dafe10b5118b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-f5e2-7344-bd6b-dafe10b5118b",
        "storage_key": "property/5734243929948160/019f150a-f5e2-7344-bd6b-dafe10b5118b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.charlottesgotalot.com/things-to-do/outdoors-adventure/nevin-community-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1531453989787497122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nevin-park",
      "poi_latitude": "35.3013914",
      "poi_longitude": "-80.83261759999999",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 980-314-1001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0572-700b-b086-c03afb396400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0572-700b-b086-c03afb396400",
        "storage_key": "property/5734243929948160/019f150b-0572-700b-b086-c03afb396400.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJs2Nxc8ygVogRonIjK0rRQBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_747b54fd145c7ea44f7fc7d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Quest at Latta Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6345 Sample Rd, Huntersville, NC 28078, USA",
      "poi_short_description": "Kids'-focused nature center with aquariums and outdoor trails as well as a picnic area.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-eae6-752c-a3f0-1a344479fe5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-eae6-752c-a3f0-1a344479fe5e",
        "storage_key": "property/5734243929948160/019f150e-eae6-752c-a3f0-1a344479fe5e.webp",
        "width": 1280,
        "height": 757
      },
      "poi_business_url": "http://www.thisisquest.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10680370245527773807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quest-at-latta-nature-preserve",
      "poi_latitude": "35.3581194",
      "poi_longitude": "-80.9071345",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 980-314-7878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0572-700b-b086-c03afb396400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0572-700b-b086-c03afb396400",
        "storage_key": "property/5734243929948160/019f150b-0572-700b-b086-c03afb396400.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8BIZ-GlVogRb6JVuiZMOJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_2503b92a62abfe33541b1cc5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Carolina Raptor Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6000 Sample Rd, Huntersville, NC 28078, USA",
      "poi_short_description": "Educational center featuring outdoor trails with live raptors, flight shows & indoor exhibits.",
      "poi_long_description": "Educational center featuring outdoor trails with live raptors, flight shows & indoor exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-f8ce-70a8-988b-c8240cc58382.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-f8ce-70a8-988b-c8240cc58382",
        "storage_key": "property/5734243929948160/019f150e-f8ce-70a8-988b-c8240cc58382.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.carolinaraptorcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=737024395228417001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carolina-raptor-center",
      "poi_latitude": "35.3503722",
      "poi_longitude": "-80.9183836",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-875-6521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7eHVxDWkVogR6QtjVMhvOgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_d90aa4e733086e15b9f41323",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "McDowell Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15222 York Rd, Charlotte, NC 28278, USA",
      "poi_short_description": "This mostly undeveloped preserve with a lake has a nature center, campground, trails & play areas.",
      "poi_long_description": "This mostly undeveloped preserve with a lake has a nature center, campground, trails & play areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-ec4e-73fb-8717-4cce8529cc09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-ec4e-73fb-8717-4cce8529cc09",
        "storage_key": "property/5734243929948160/019f150e-ec4e-73fb-8717-4cce8529cc09.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/Nature",
      "poi_directions_map_url": "https://maps.google.com/?cid=12384465943190315836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcdowell-nature-preserve",
      "poi_latitude": "35.0964855",
      "poi_longitude": "-81.0239543",
      "poi_miles_from_property": "24.9 mi",
      "poi_walking_minutes": "9 hours 13 mins",
      "poi_biking_minutes": "2 hours 24 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 980-314-1128",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0572-700b-b086-c03afb396400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0572-700b-b086-c03afb396400",
        "storage_key": "property/5734243929948160/019f150b-0572-700b-b086-c03afb396400.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Zk81PaQVogRPCPI3Ch23qs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_65150ecd8aca339806ed4282",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "UNC Charlotte Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9090 Craver Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_long_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150e-f7bb-725b-8c62-460fd442b90a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-f7bb-725b-8c62-460fd442b90a",
        "storage_key": "property/5734243929948160/019f150e-f7bb-725b-8c62-460fd442b90a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://gardens.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4177973296962421892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-botanical-gardens",
      "poi_latitude": "35.3078198",
      "poi_longitude": "-80.72969499999999",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 704-687-0721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6cM9xocVIgRhESD5pMk-zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_e0c51e0dce17a4582d658fbd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Jetton Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19000 Jetton Rd, Cornelius, NC 28031, USA",
      "poi_short_description": "Tree-covered 104-acre park on Lake Norman with a small beach, tennis courts, a trail & picnic area.",
      "poi_long_description": "Tree-covered 104-acre park on Lake Norman with a small beach, tennis courts, a trail & picnic area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-0cbb-726c-b436-de23c02b805a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-0cbb-726c-b436-de23c02b805a",
        "storage_key": "property/5734243929948160/019f150f-0cbb-726c-b436-de23c02b805a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Activities/fishing",
      "poi_directions_map_url": "https://maps.google.com/?cid=8061203737565487180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jetton-park",
      "poi_latitude": "35.4745684",
      "poi_longitude": "-80.899168",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 22 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 980-314-1001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0572-700b-b086-c03afb396400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0572-700b-b086-c03afb396400",
        "storage_key": "property/5734243929948160/019f150b-0572-700b-b086-c03afb396400.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPZjwJkSvVogRTGCk1xYm328",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_808f3bf7b5a061337d1bffb7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Mallard Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3001 Johnston Oehler Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Recreation area featuring 8 soccer fields, a batting cage, and 2 playgrounds, plus a volleyball court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-0766-70fe-b210-733ec5779e0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-0766-70fe-b210-733ec5779e0d",
        "storage_key": "property/5734243929948160/019f150f-0766-70fe-b210-733ec5779e0d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=412983690555762575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-park",
      "poi_latitude": "35.3614698",
      "poi_longitude": "-80.7624001",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0572-700b-b086-c03afb396400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0572-700b-b086-c03afb396400",
        "storage_key": "property/5734243929948160/019f150b-0572-700b-b086-c03afb396400.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB6J0seEcVIgRjyebfXo2uwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f1733cf998e64289ceaf9687",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Reedy Creek Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2900 Rocky River Rd, Charlotte, NC 28215, USA",
      "poi_short_description": "Creekside walks & fishing spots in woodland with picnic shelters & ruins of pioneer-era cabins.",
      "poi_long_description": "Creekside walks & fishing spots in woodland with picnic shelters & ruins of pioneer-era cabins.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-02f9-70bb-ab7b-4cb692776eab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-02f9-70bb-ab7b-4cb692776eab",
        "storage_key": "property/5734243929948160/019f150f-02f9-70bb-ab7b-4cb692776eab.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/Nature/reedy-creek-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=4056376883772919066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reedy-creek-nature-preserve",
      "poi_latitude": "35.26378750000001",
      "poi_longitude": "-80.71209840000002",
      "poi_miles_from_property": "13.4 mi",
      "poi_walking_minutes": "4 hours 56 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 980-314-1119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0572-700b-b086-c03afb396400.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0572-700b-b086-c03afb396400",
        "storage_key": "property/5734243929948160/019f150b-0572-700b-b086-c03afb396400.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYzQOkoZVIgRGg1kwEglSzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_713695f858179c5a568f296a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Northlake Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11574504833305702147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northlake-mall-park--ride",
      "poi_latitude": "35.352833",
      "poi_longitude": "-80.85521899999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVfdxJlWmVogRA286UNLmoKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_e63a43b7f2064f9a5221c109",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Riverbend Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8842128954005509861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverbend-park-and-ride",
      "poi_latitude": "35.32882",
      "poi_longitude": "-80.94192",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKf5NEWKkVogR5daxoW-NtXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_96780eaaa14e8f184e63895a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Mallard Creek Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2158274625695479655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-park--ride",
      "poi_latitude": "35.32323",
      "poi_longitude": "-80.77292",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcW0-QLYdVIgRZ3dRSFa78x0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_4ab552970268e4d7ace933fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "McCullough",
      "poi_type": "Transportation & Transit",
      "poi_address": "8312 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-0702-7581-8c8d-ccc25c49455b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-0702-7581-8c8d-ccc25c49455b",
        "storage_key": "property/5734243929948160/019f150f-0702-7581-8c8d-ccc25c49455b.webp",
        "width": 1280,
        "height": 674
      },
      "poi_business_url": "http://charlottenc.gov/cats/rail/lynx-blue-line/Pages/mccullough-station.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1260187329938804696&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mccullough",
      "poi_latitude": "35.301124",
      "poi_longitude": "-80.752875",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_ReviccVIgR2E9zJ7MVfRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_ee1e9adc72ed828a5ae42670",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "JW Clay Blvd / UNC Charlotte",
      "poi_type": "Transportation & Transit",
      "poi_address": "9234-9300 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-2051-75fb-81d9-e3b79d3c142c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-2051-75fb-81d9-e3b79d3c142c",
        "storage_key": "property/5734243929948160/019f150f-2051-75fb-81d9-e3b79d3c142c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.charlottenc.gov/CATS/Rail/LYNX-Stations-and-Park-and-Rides/JW-Clay-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=9941066239111075827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jw-clay-blvd--unc-charlotte",
      "poi_latitude": "35.3108328",
      "poi_longitude": "-80.7450265",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wiIej0cVIgR8xfYDhPD9Yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_a72557e4ad6ffab97b0ed6f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "UNC Charlotte Main Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "9025 Cameron Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-105d-728c-9d53-4ebb8ee32296.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-105d-728c-9d53-4ebb8ee32296",
        "storage_key": "property/5734243929948160/019f150f-105d-728c-9d53-4ebb8ee32296.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "http://charlottenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11588625435149076740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-main-station",
      "poi_latitude": "35.3121822",
      "poi_longitude": "-80.73371980000002",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDTHpFBEcVIgRBAkeIW8R06A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_72fea71f9397be180e10c5b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "University City Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "7205 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-157c-759f-a11a-d66e3d9222d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-157c-759f-a11a-d66e3d9222d3",
        "storage_key": "property/5734243929948160/019f150f-157c-759f-a11a-d66e3d9222d3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://charlonbvcsattenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=12467337922677263454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-city-blvd",
      "poi_latitude": "35.2869215",
      "poi_longitude": "-80.76073650000001",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZz4QjIUeVIgRXkzvL8nhBK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_f568bf94edc8d849cf4640e0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Amtrak Charlotte Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1914 N Tryon St, Charlotte, NC 28206, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-1a7b-7628-a84a-1ba16b4e3dde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-1a7b-7628-a84a-1ba16b4e3dde",
        "storage_key": "property/5734243929948160/019f150f-1a7b-7628-a84a-1ba16b4e3dde.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.amtrak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17371830586323027624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak-charlotte-station",
      "poi_latitude": "35.2412903",
      "poi_longitude": "-80.8226901",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 866-227-0296",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvZ3bklOhVogRqMYM3OAjFfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "ec_4176a1a9ef2559d4f7252991",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Charlotte Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "310 E Trade St, Charlotte, NC 28202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4144275419840309105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-transportation-center",
      "poi_latitude": "35.2246882",
      "poi_longitude": "-80.8406333",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN63efwChVogRcef2eolsgzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_eaaacfb6790a241925021f7b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-1f87-77fb-998f-1a2fb86a8769.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-1f87-77fb-998f-1a2fb86a8769",
        "storage_key": "property/5734243929948160/019f150f-1f87-77fb-998f-1a2fb86a8769.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "17.0 mi",
      "poi_walking_minutes": "6 hours 17 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-35db-77d7-814f-4d127e045055.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150f-35db-77d7-814f-4d127e045055",
        "storage_key": "property/5734243929948160/019f150f-35db-77d7-814f-4d127e045055.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_c5060bb896732df1d424047b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "University of North Carolina at Charlotte",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9201 University City Blvd, Charlotte, NC 28223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-2129-76f9-86e2-4077205368e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-2129-76f9-86e2-4077205368e1",
        "storage_key": "property/5734243929948160/019f150f-2129-76f9-86e2-4077205368e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728009800198595827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-carolina-at-charlotte",
      "poi_latitude": "35.3074169",
      "poi_longitude": "-80.73521219999999",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-05a3-753f-9ccf-b1a530fecbd8",
        "storage_key": "property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyOp0BocVIgR8yST8fdnP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_0ed69cd5021fbd7e610334cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "University Research Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "David Taylor Dr &, Andrew Carnegie Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6219936161875630100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-research-park",
      "poi_latitude": "35.321521",
      "poi_longitude": "-80.755825",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlwUdBogdVIgRFBg0DvymUVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_c384fbc2747e1b2cef09ebcb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "EPRI",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1300 W W.T.Harris Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-1a25-7638-9bbb-efc887c48d24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-1a25-7638-9bbb-efc887c48d24",
        "storage_key": "property/5734243929948160/019f150f-1a25-7638-9bbb-efc887c48d24.webp",
        "width": 715,
        "height": 538
      },
      "poi_business_url": "http://www.epri.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11788191978884899839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "epri",
      "poi_latitude": "35.3160623",
      "poi_longitude": "-80.76681839999999",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-595-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-05a3-753f-9ccf-b1a530fecbd8",
        "storage_key": "property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPbIloMwdVIgR_yOL9SUSmKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "research_institute"
    },
    {
      "id": "ec_9015b42740f3ea6367f0511b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Atrium Health University City",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8800 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-2505-72df-879e-fe78a01f789e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-2505-72df-879e-fe78a01f789e",
        "storage_key": "property/5734243929948160/019f150f-2505-72df-879e-fe78a01f789e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-university-city?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=7076796399763319050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-university-city",
      "poi_latitude": "35.3066306",
      "poi_longitude": "-80.7472512",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 704-863-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0572-700b-b086-bdf593d06398.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0572-700b-b086-bdf593d06398",
        "storage_key": "property/5734243929948160/019f150b-0572-700b-b086-bdf593d06398.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpeG8ryMcVIgRCumnw9TUNWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_a1075ac56443f6b048d90a1e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Novant Health Huntersville Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10030 Gilead Rd, Huntersville, NC 28078, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150a-f13c-71da-a568-d10db24854d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-f13c-71da-a568-d10db24854d9",
        "storage_key": "property/5734243929948160/019f150a-f13c-71da-a568-d10db24854d9.webp",
        "width": 1280,
        "height": 842
      },
      "poi_business_url": "https://www.novanthealth.org/locations/medical-centers/huntersville-medical-center/?utm_source=maps.google.com&utm_medium=organic&utm_campaign=GBP&utm_content=MC-06",
      "poi_directions_map_url": "https://maps.google.com/?cid=4170292178518567466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "novant-health-huntersville-medical-center",
      "poi_latitude": "35.4065406",
      "poi_longitude": "-80.8607439",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-316-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0572-700b-b086-bdf593d06398.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0572-700b-b086-bdf593d06398",
        "storage_key": "property/5734243929948160/019f150b-0572-700b-b086-bdf593d06398.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJtboxfY-oVogRKmowJqTa3zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_b3171af10b00fc5cc8773833",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Central Piedmont Community College - Merancas Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11930 Verhoeff Dr, Huntersville, NC 28078, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-2758-744b-8562-a9a12bbdaa62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-2758-744b-8562-a9a12bbdaa62",
        "storage_key": "property/5734243929948160/019f150f-2758-744b-8562-a9a12bbdaa62.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cpcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16605828799299733723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-piedmont-community-college---merancas-campus",
      "poi_latitude": "35.3928478",
      "poi_longitude": "-80.8405035",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-330-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-05a3-753f-9ccf-b1a530fecbd8",
        "storage_key": "property/5734243929948160/019f150b-05a3-753f-9ccf-b1a530fecbd8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbd0bJnaoVogR20g2v0_Bc-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_d46ea9483a16d32d4f7edee4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Northlake Mall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6801 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Department stores & name-brand retailers in a modern mall with a movie theater & casual eateries.",
      "poi_long_description": "Department stores & name-brand retailers in a modern mall with a movie theater & casual eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150a-dc7b-73ec-b362-3c1fbe72f46d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-dc7b-73ec-b362-3c1fbe72f46d",
        "storage_key": "property/5734243929948160/019f150a-dc7b-73ec-b362-3c1fbe72f46d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.shopnorthlake.com/?utm_source=google&utm_medium=organic&utm_campaign=GMB&utm_content=SW22_NORLAKE",
      "poi_directions_map_url": "https://maps.google.com/?cid=7112540795624693928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northlake-mall",
      "poi_latitude": "35.352657",
      "poi_longitude": "-80.8511821",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-447-1744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0584-776a-ac8f-8dbefbb31d64",
        "storage_key": "property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlz5hUaqnVogRqCCvdSvStGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_c930e9d69a925cb5e9f61cdc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "The Shoppes at University Place",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8931 J M Keynes Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Shopping center with restaurants and stores, plus a boardwalk with paddleboats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-2adf-762c-a28c-8ab518dd2acd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-2adf-762c-a28c-8ab518dd2acd",
        "storage_key": "property/5734243929948160/019f150f-2adf-762c-a28c-8ab518dd2acd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shoppesatuniversityplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14212933022838765680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-shoppes-at-university-place",
      "poi_latitude": "35.309802",
      "poi_longitude": "-80.748663",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-0584-776a-ac8f-8dbefbb31d64",
        "storage_key": "property/5734243929948160/019f150b-0584-776a-ac8f-8dbefbb31d64.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_Wp0EEIdVIgRcDi56kd7PsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_70812129dfc506b9e83981e0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Wells Fargo",
      "poi_type": "Major Employers & Offices",
      "poi_address": "CIC BLDG 3, 1525 W W.T.Harris Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Private campus featuring a full fitness center, a bank and a mile-long nature trail.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-2b38-73d6-b0ba-d7f918728884.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-2b38-73d6-b0ba-d7f918728884",
        "storage_key": "property/5734243929948160/019f150f-2b38-73d6-b0ba-d7f918728884.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wellsfargo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7301539158896786941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wells-fargo",
      "poi_latitude": "35.31183559999999",
      "poi_longitude": "-80.77074809999999",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-869-3557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09nIF84dVIgR_b2lBy5HVGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_f5d74602d0f9fedbc5217e82",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "poi_name": "Truliant Amphitheater",
      "poi_type": "Major Employers & Offices",
      "poi_address": "707 Pavilion Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Sprawling outdoor venue for a variety of musical acts, from country to R&B, plus festivals & events.",
      "poi_long_description": "Sprawling outdoor venue for a variety of musical acts, from country to R&B, plus festivals & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150f-2b3d-70c4-8cfc-3dcf2e2f5154.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150f-2b3d-70c4-8cfc-3dcf2e2f5154",
        "storage_key": "property/5734243929948160/019f150f-2b3d-70c4-8cfc-3dcf2e2f5154.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.truliantamp.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8876681391951831978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "truliant-amphitheater",
      "poi_latitude": "35.3271592",
      "poi_longitude": "-80.7123113",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 29 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-549-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150b-059c-77ae-8577-616fdab722a5",
        "storage_key": "property/5734243929948160/019f150b-059c-77ae-8577-616fdab722a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC2hDco8bVIgRquOb_7FOMHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    }
  ],
  "office_hours": [
    {
      "id": "custom_56d88e85-762d-45f9-b83c-8338b98ebdee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_93053c12-f817-479b-aadd-315504497c2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_618038e0-9054-45d4-879f-efc5b3d6d12f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f25cf13c-c5dd-4ae9-8b10-bf521beeeba8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d3efc036-443c-4173-b2fe-0da64f775e1d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_947537e8-e5b4-436c-abb7-daf97fed9797",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_ce12694a-40a4-4e87-8f6a-ad2fcf8cdbbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_1f08f2e027ac3cac1e5615e5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "rating": "5",
      "name": "Candice Foreman",
      "text": "JeAnna was so kind and helpful during my difficult situation. I was moving from 2-bedroom to a 1-bedroom and she made sure that I had everything that I needed. She also kept in communication with me which is huge. If you need help at the leasing office, go to her and she will definitely take care of you!",
      "date": "2026-01-31",
      "title": "false"
    },
    {
      "id": "ec_81242d399a8e24dfcf6827be",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "rating": "5",
      "name": "Shauntay Stewart",
      "text": "I’ve been living here for 6 going on 7 years and it’s been a pleasure! I’ve had a great experience living at this apartment community. The property is well maintained, the environment is peaceful, and everything is conveniently located. I especially want to give a shout-out to Sarah and Ms. Paula—they are absolutely amazing! They are always friendly, professional, and genuinely care about the residents. Any questions or concerns are handled quickly, and they truly go above and beyond to make you feel at home. I’m very happy living here and would definitely recommend this community to anyone looking for a great place to live.",
      "date": "2025-12-13",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_671896912fd24fddb2cf4d2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f14c4-6f28-73e8-a352-ea3e36e911e1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-6f28-73e8-a352-ea3e36e911e1",
        "storage_key": "property/5734243929948160/019f14c4-6f28-73e8-a352-ea3e36e911e1.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Celsius Apartments - Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/4p94tY-czzc"
    }
  ],
  "faqs": [
    {
      "id": "custom_ce46faf5-d241-429d-96a6-4ee9c802a16d",
      "question": "Is Celsius Apartment Homes pet-friendly?",
      "answer": "Yes. Celsius Apartment Homes welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (704) 399-8805 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_e303eced-ee61-46cf-a017-8bf78546c3b8",
      "question": "How can I schedule a tour at Celsius Apartment Homes?",
      "answer": "You can schedule a tour of Celsius Apartment Homes online through our Schedule a Tour page, or call the leasing office at (704) 399-8805. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_8c03378c-8334-4659-8552-a9c9bc64eeb8",
      "question": "What are the leasing office hours at Celsius Apartment Homes?",
      "answer": "The Celsius Apartment Homes leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (704) 399-8805 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_f5e83333-a5eb-4602-bf07-2b70aee1a778",
      "question": "What floor plans are available at Celsius Apartment Homes?",
      "answer": "Celsius Apartment Homes offers 1- to 3-bedroom apartment homes ranging from approximately 713 to 1,423 square feet, across 31 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_aa238e90-869d-4ba1-bc43-158331d09ca7",
      "question": "What amenities does Celsius Apartment Homes have?",
      "answer": "Celsius Apartment Homes offers a range of community and in-home amenities. Community amenities include: LUXER Package Locker, American Landmark 360, Billiards, Car Wash, Clubhouse, Coffee Bar, Dog Park, Dog Spa, Fire Pit, Fitness Center, Garages, Online Resident Services, Pool, Recycling Center, Select Homes, and Wifi. In-home features include: cabinets, counters, digital thermostats, garden tub, kitchen appliances, kitchen islands, outside space, tall ceilings, tile backsplash, usb outlet, and w&d included. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_f5d3c288-0723-41a3-971d-76e92d7cd863",
      "question": "Where is Celsius Apartment Homes located?",
      "answer": "Celsius Apartment Homes is located at 10051 Perimeter Station Dr, Charlotte NC 28216. Nearby you'll find dining at Firebirds Wood Fired Grill, shopping at Target, and green space at Long Creek Greenway. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_e1ef039e-ce59-4ef8-a1e4-96cc525368b6",
      "question": "How do I apply to live at Celsius Apartment Homes?",
      "answer": "You can apply to live at Celsius Apartment Homes online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (704) 399-8805 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_306889e0-1e7e-4aa8-acad-e70e1d5b45e9",
      "question": "What do I need to apply at Celsius Apartment Homes?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Celsius Apartment Homes leasing team at (704) 399-8805 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_0436412b-e5ee-4322-8906-4dca1caca88f",
      "question": "What is the Landmark 360 program at Celsius Apartment Homes?",
      "answer": "Celsius Apartment Homes participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (704) 399-8805 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_3ca91993-396a-4c85-8bb1-d6282588de27",
      "question": "Does Celsius Apartment Homes have a pool?",
      "answer": "Yes. Celsius Apartment Homes has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_45e31448-2932-4399-b216-32aa73b0b609",
      "question": "Does Celsius Apartment Homes have a fitness center?",
      "answer": "Yes. Celsius Apartment Homes has a fitness center for residents. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_4aca6ad5-807a-4f14-841d-0b230ec87ec1",
      "question": "Does Celsius Apartment Homes have a dog park?",
      "answer": "Yes. Celsius Apartment Homes has an on-site dog park for residents and their dogs. See more community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_4853e6d7-677c-4806-be2e-35584a89e684",
      "question": "Does Celsius Apartment Homes offer virtual tours?",
      "answer": "Yes. Celsius Apartment Homes offers virtual tours of Celsius Apartments - Community Tour. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_736658ce-4953-4b9f-8897-3f6f272306ba",
      "question": "What do residents say about living at Celsius Apartment Homes?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Celsius Apartment Homes. One resident wrote: *\"I’ve been living here for 6 going on 7 years and it’s been a pleasure! I’ve had a great experience living at this apartment community. The property is well maintained, the environment is peaceful, and everything is conveniently located.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_15047ce3-85e7-4683-9cb8-b1c782362e90",
      "question": "When was Celsius Apartment Homes built?",
      "answer": "Celsius Apartment Homes was built in 2009 and renovated in 2022. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_8c570e88-b207-4385-b818-ecffcb1ebff4",
      "question": "What is the pet fee at Celsius Apartment Homes?",
      "answer": "Pets at Celsius Apartment Homes: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (704) 399-8805 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_ab190625-130f-4c88-9231-7a1b72246799",
      "question": "What features are included in the apartments at Celsius Apartment Homes?",
      "answer": "Apartment homes at Celsius Apartment Homes include cabinets, counters, digital thermostats, garden tub, kitchen appliances, kitchen islands, outside space, tall ceilings, tile backsplash, usb outlet, and w&d included. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_f9027eb9-fc03-4181-a80a-aad73689d30a",
      "question": "What restaurants and shops are near Celsius Apartment Homes?",
      "answer": "Nearby restaurants and shops include Firebirds Wood Fired Grill, Parry's Pizzeria & Taphouse, Showmars Northlake Mall, and Chick-fil-A. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-60dd-724e-95d5-6fd57bfc9644",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "celsius-apartment-homes",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160"
    },
    {
      "lead_collector_id": "0198aa45-613f-7069-8b33-17da458f2cea",
      "lead_source": "FACEBOOK_ADS",
      "name": "celsius-apartment-homes",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160"
    },
    {
      "lead_collector_id": "0198aa45-61a2-7089-8ea9-0dd43c27a34c",
      "lead_source": "LANDING_PAGE",
      "name": "celsius-apartment-homes",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-charlotte-nc",
      "search_query": "One Bedroom Apartments For Rent In Charlotte NC",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In Charlotte NC",
      "h2_subtitle": "Discover modern living at Celsius Apartment Homes. Our one-bedroom apartments offer contemporary features and a prime location near Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our one-bedroom apartments for rent in Charlotte NC offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | One Bedroom Apartments For Rent In Charlotte NC",
      "seo_description": "Discover one bedroom apartments for rent in Charlotte NC at Celsius Apartment Homes. Enjoy modern features and a prime location near Northlake Mall. Welcome to modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-charlotte-nc",
      "search_query": "Two Bedrooms Apartments For Rent In Charlotte NC",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In Charlotte NC",
      "h2_subtitle": "Experience the best of modern living at Celsius Apartment Homes. Our two-bedroom apartments feature contemporary designs and are conveniently located near Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our two bedrooms apartments for rent in Charlotte NC offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Two Bedrooms Apartments For Rent In Charlotte NC",
      "seo_description": "Explore two bedrooms apartments for rent in Charlotte NC at Celsius Apartment Homes. Enjoy modern features and a prime location near Northlake Mall. Welcome to modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "three-bedrooms-apartments-for-rent-charlotte-nc",
      "search_query": "Three Bedrooms Apartments For Rent In Charlotte NC",
      "category": "Floorplan",
      "h1_title": "Three Bedrooms Apartments For Rent In Charlotte NC",
      "h2_subtitle": "Elevate your lifestyle at Celsius Apartment Homes. Our three-bedroom apartments offer modern features and a prime location near Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our three bedrooms apartments for rent in Charlotte NC offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Three Bedrooms Apartments For Rent In Charlotte NC",
      "seo_description": "Discover three bedrooms apartments for rent in Charlotte NC at Celsius Apartment Homes. Enjoy modern features and a prime location near Northlake Mall. Welcome to modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-bark-park-for-pets",
      "search_query": "Apartments For Rent Near Me with Bark Park For Your Furry Friends",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Bark Park For Your Furry Friends",
      "h2_subtitle": "Enjoy pet-friendly living at Celsius Apartment Homes. Our community features a bark park for your furry friends and a prime location near Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent near me with bark park for your furry friends offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent Near Me with Bark Park For Your Furry Friends",
      "seo_description": "Find apartments for rent near me with bark park for your furry friends at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall in Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-posh-pet-spa",
      "search_query": "Apartments For Rent Near Me with Posh Pet Spa",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Posh Pet Spa",
      "h2_subtitle": "Pamper your pets at Celsius Apartment Homes. Our community features a posh pet spa and a prime location near Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent near me with posh pet spa offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent Near Me with Posh Pet Spa",
      "seo_description": "Find apartments for rent near me with posh pet spa at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall in Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-private-patio-balcony",
      "search_query": "Apartments For Rent Near Me with Private Patio or Balcony",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Private Patio or Balcony",
      "h2_subtitle": "Relax in style at Celsius Apartment Homes. Our community features apartments with private patios or balconies and a prime location near Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent near me with private patio or balcony offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent Near Me with Private Patio or Balcony",
      "seo_description": "Find apartments for rent near me with private patio or balcony at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall in Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-fresenius-medical-care",
      "search_query": "Apartments For Rent In Charlotte NC Near Fresenius Medical Care at Cmc University",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Fresenius Medical Care at Cmc University",
      "h2_subtitle": "Discover convenient living at Celsius Apartment Homes. Our community offers modern apartments near Fresenius Medical Care at Cmc University and Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent in Charlotte NC near Fresenius Medical Care at Cmc University offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent In Charlotte NC Near Fresenius Medical Care at Cmc University",
      "seo_description": "Find apartments for rent in Charlotte NC near Fresenius Medical Care at Cmc University at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-novant-health",
      "search_query": "Apartments For Rent In Charlotte NC Near Novant Health Huntersville Medical Center",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Novant Health Huntersville Medical Center",
      "h2_subtitle": "Live conveniently at Celsius Apartment Homes. Our community offers modern apartments near Novant Health Huntersville Medical Center and Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent in Charlotte NC near Novant Health Huntersville Medical Center offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent In Charlotte NC Near Novant Health Huntersville Medical Center",
      "seo_description": "Find apartments for rent in Charlotte NC near Novant Health Huntersville Medical Center at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-atrium-health",
      "search_query": "Apartments For Rent In Charlotte NC Near Atrium Health University City",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Atrium Health University City",
      "h2_subtitle": "Enjoy convenient living at Celsius Apartment Homes. Our community offers modern apartments near Atrium Health University City and Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent in Charlotte NC near Atrium Health University City offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent In Charlotte NC Near Atrium Health University City",
      "seo_description": "Find apartments for rent in Charlotte NC near Atrium Health University City at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-carolinas-hospitalist",
      "search_query": "Apartments For Rent In Charlotte NC Near Carolinas Hospitalist Group",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Carolinas Hospitalist Group",
      "h2_subtitle": "Discover convenient living at Celsius Apartment Homes. Our community offers modern apartments near Carolinas Hospitalist Group and Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent in Charlotte NC near Carolinas Hospitalist Group offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent In Charlotte NC Near Carolinas Hospitalist Group",
      "seo_description": "Find apartments for rent in Charlotte NC near Carolinas Hospitalist Group at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-gastroenterology-hepatology",
      "search_query": "Apartments For Rent In Charlotte NC Near Charlotte Gastroenterology & Hepatology Lake Norman Endoscopy Center",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Charlotte Gastroenterology & Hepatology Lake Norman Endoscopy Center",
      "h2_subtitle": "Live conveniently at Celsius Apartment Homes. Our community offers modern apartments near Charlotte Gastroenterology & Hepatology Lake Norman Endoscopy Center and Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent in Charlotte NC near Charlotte Gastroenterology & Hepatology Lake Norman Endoscopy Center offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent In Charlotte NC Near Charlotte Gastroenterology & Hepatology Lake Norman Endoscopy Center",
      "seo_description": "Find apartments for rent in Charlotte NC near Charlotte Gastroenterology & Hepatology Lake Norman Endoscopy Center at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-uncc",
      "search_query": "Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "h2_subtitle": "Experience convenient living at Celsius Apartment Homes. Our community offers modern apartments near the University of North Carolina at Charlotte and Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent in Charlotte NC near University of North Carolina at Charlotte offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "seo_description": "Find apartments for rent in Charlotte NC near University of North Carolina at Charlotte at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-belmont-abbey",
      "search_query": "Apartments For Rent In Charlotte NC Near Belmont Abbey College",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Belmont Abbey College",
      "h2_subtitle": "Discover convenient living at Celsius Apartment Homes. Our community offers modern apartments near Belmont Abbey College and Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent in Charlotte NC near Belmont Abbey College offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent In Charlotte NC Near Belmont Abbey College",
      "seo_description": "Find apartments for rent in Charlotte NC near Belmont Abbey College at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-wake-forest-business",
      "search_query": "Apartments For Rent In Charlotte NC Near Wake Forest University School of Business Charlotte campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Wake Forest University School of Business Charlotte campus",
      "h2_subtitle": "Experience convenient living at Celsius Apartment Homes. Our community offers modern apartments near Wake Forest University School of Business Charlotte campus and Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent in Charlotte NC near Wake Forest University School of Business Charlotte campus offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent In Charlotte NC Near Wake Forest University School of Business Charlotte campus",
      "seo_description": "Find apartments for rent in Charlotte NC near Wake Forest University School of Business Charlotte campus at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-cpcc-harris-campus",
      "search_query": "Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Harris Campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Harris Campus",
      "h2_subtitle": "Discover convenient living at Celsius Apartment Homes. Our community offers modern apartments near Central Piedmont Community College - Harris Campus and Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent in Charlotte NC near Central Piedmont Community College - Harris Campus offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Harris Campus",
      "seo_description": "Find apartments for rent in Charlotte NC near Central Piedmont Community College - Harris Campus at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-cato-middle-college",
      "search_query": "Apartments For Rent In Charlotte NC Near Cato Middle College High",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Cato Middle College High",
      "h2_subtitle": "Experience convenient living at Celsius Apartment Homes. Our community offers modern apartments near Cato Middle College High and Northlake Mall.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent in Charlotte NC near Cato Middle College High offer a blend of contemporary features with sleek style. Located near the Northlake Mall and the I-77, you’ll be close to downtown while away from the city's hustle. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent In Charlotte NC Near Cato Middle College High",
      "seo_description": "Find apartments for rent in Charlotte NC near Cato Middle College High at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-hornets-nest",
      "search_query": "Apartments For Rent In Charlotte NC Near Hornets Nest Elementary",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Hornets Nest Elementary",
      "h2_subtitle": "Perfect for families, Celsius Apartment Homes offers modern living just 4.5 km from Hornets Nest Elementary. Enjoy a prime location and family-friendly amenities.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent in Charlotte NC near Hornets Nest Elementary are ideal for families looking for a convenient and modern living space. Located just 4.5 km from Hornets Nest Elementary, you’ll enjoy easy access to one of the top schools in the Charlotte-Mecklenburg Schools district. Our one, two, and three-bedroom floor plans offer a blend of contemporary features with sleek style. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent In Charlotte NC Near Hornets Nest Elementary",
      "seo_description": "Find family-friendly apartments for rent in Charlotte NC near Hornets Nest Elementary at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-north-mecklenburg",
      "search_query": "Apartments For Rent In Charlotte NC Near North Mecklenburg High School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near North Mecklenburg High School",
      "h2_subtitle": "Ideal for families, Celsius Apartment Homes offers modern living just 6.4 km from North Mecklenburg High School. Enjoy a prime location and family-friendly amenities.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent in Charlotte NC near North Mecklenburg High School are perfect for families seeking a convenient and modern living space. Located just 6.4 km from North Mecklenburg High School, you’ll enjoy easy access to one of the top schools in the area. Our one, two, and three-bedroom floor plans offer a blend of contemporary features with sleek style. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent In Charlotte NC Near North Mecklenburg High School",
      "seo_description": "Find family-friendly apartments for rent in Charlotte NC near North Mecklenburg High School at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-hopewell-high",
      "search_query": "Apartments For Rent In Charlotte NC Near Hopewell High",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Hopewell High",
      "h2_subtitle": "Perfect for families, Celsius Apartment Homes offers modern living just 9.0 km from Hopewell High. Enjoy a prime location and family-friendly amenities.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent in Charlotte NC near Hopewell High are ideal for families looking for a convenient and modern living space. Located just 9.0 km from Hopewell High, you’ll enjoy easy access to one of the top schools in the area. Our one, two, and three-bedroom floor plans offer a blend of contemporary features with sleek style. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent In Charlotte NC Near Hopewell High",
      "seo_description": "Find family-friendly apartments for rent in Charlotte NC near Hopewell High at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5734243929948160",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-ranson-middle",
      "search_query": "Apartments For Rent In Charlotte NC Near Ranson Middle",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Ranson Middle",
      "h2_subtitle": "Perfect for families, Celsius Apartment Homes offers modern living just 8.0 km from Ranson Middle. Enjoy a prime location and family-friendly amenities.",
      "page_copy": "Choose how you chill with life at Celsius Apartment Homes in Charlotte, North Carolina. Our apartments for rent in Charlotte NC near Ranson Middle are ideal for families seeking a convenient and modern living space. Located just 8.0 km from Ranson Middle, you’ll enjoy easy access to one of the top schools in the Charlotte-Mecklenburg Schools district. Our one, two, and three-bedroom floor plans offer a blend of contemporary features with sleek style. After a busy day, retreat to a resort-style community to relax, reset, and recharge. Take a swim in one of two onsite swimming pools before soaking up the sun’s rays on the sundeck. Finish your day hanging out on your private patio or balcony, taking in the fresh air and good vibes of Celsius Apartment Homes. Welcome to modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
      "featured_image_media": {
        "alt_text": "Luxury apartment complex with a resort-style swimming pool and lounge chairs.",
        "public_id": "019f6c0d-31a2-722e-a42c-8fd1c25cbbaa",
        "storage_key": "property/5734243929948160/019f6c0d-31a2-722e-a42c-8fd1c25cbbaa.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
      "blank_image_media": {
        "alt_text": "Building exterior",
        "public_id": "019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e",
        "storage_key": "property/5734243929948160/019f6c0d-3aa2-73bb-a8e0-bd4b48c53d1e.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Celsius Apartment Homes | Apartments For Rent In Charlotte NC Near Ranson Middle",
      "seo_description": "Find family-friendly apartments for rent in Charlotte NC near Ranson Middle at Celsius Apartment Homes. Enjoy modern living and a prime location near Northlake Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2149"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471405"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a20\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a20\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4868212"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TKRPQKS"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://celsiusapa.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443864152"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/dqw9ed28po9"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/0be9b8db-95d7-4217-9b58-238eb671aac2"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "704-742-2429"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImNBWlVkakovUm5RYlVMWkkwZ0RxbXc9PSIsInZhbHVlIjoiaVRGaWRmTTFERzdseGJhV2RUUlN1QT09IiwibWFjIjoiMWMyZDM4MjdmOWY5NTI2ZWI4ZThhNzY1YThlN2ZjZTIzZDczNWNkYjdhZjlkODA4NTk5OWU5OWFmYWE0NzA3ZSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2149",
  "custom_repli_id": "2376471405",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a20\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a20\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4868212",
  "custom_google_gtm_id": "GTM-TKRPQKS",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://celsiusapa.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443864152",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/dqw9ed28po9",
  "custom_self_guided_tour_url": "https://selftournow.com/property/0be9b8db-95d7-4217-9b58-238eb671aac2",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "704-742-2429",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImNBWlVkakovUm5RYlVMWkkwZ0RxbXc9PSIsInZhbHVlIjoiaVRGaWRmTTFERzdseGJhV2RUUlN1QT09IiwibWFjIjoiMWMyZDM4MjdmOWY5NTI2ZWI4ZThhNzY1YThlN2ZjZTIzZDczNWNkYjdhZjlkODA4NTk5OWU5OWFmYWE0NzA3ZSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "9352e60e-3032-4cdf-b628-d89ee1ea7a8a",
  "custom_audioeye_site_hash": "ce65154c0f39fab62de7063bb45e403f"
};

export const generatedAt = '2026-10-06T17:03:54.587Z';
